import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import HlsToolBar from 'components/HlsToolbar';
import axios from 'axios';
import LayoutPanel from 'components/LayoutPanel';
import SideMenu from 'components/SideMenu';
import HlsSideMenu from 'components/HlsSideMenu';
import { toast } from 'react-hot-toast';
import {
  checkDivsInMainPanel,
  checkCanControl,
  canControlBroadcast,
  isPrimaryHost,
  isCoHost,
  hasActiveControl,
  addRoleLabelToVideo,
  restoreBroadcastUI
} from 'utils';

import {
  SET_LOCAL_AUDIO,
  SET_LOCAL_VIDEO,
  SET_BACKGROUND_FILTER,
} from 'store/WaitingRoom/waitingRoomAction';
const ManualComponent = () => {
  const [buttonState, setButtonState] = useState('');
  const [broadcastId, setBroadcastId] = useState('');
  const [states, setStates] = useState(false);
  const [hlsLink, setHlsLink] = useState('');
  const [condition, setCondition] = useState(false);
  let { pid, roleName, userName, userId } = useParams();
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [sessionId, setSessionId] = useState();
  const [stats, setStats] = useState(null);
  const dispatch = useDispatch();
  const [streamData, setStreamData] = useState();
  const connectionUserMap = useRef(new Map());
  const [count, setCount] = useState();
  const [streams, setStreams] = useState();
  const [isCurrentHost, setIsCurrentHost] = useState(false);
  const [broadcastType, setBroadcastType] = useState('auto');
  const [broadcastError, setBroadcastError] = useState(null);
  const [mediaChannelStatus, setMediaChannelStatus] = useState(null);
  const [isRetrying, setIsRetrying] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isBroadcastStarting, setIsBroadcastStarting] = useState(false);
  const [userPermission, setUserPermission] = useState();
  const state = useSelector((state) => state);
  const userData = JSON.parse(sessionStorage.getItem('userData'));
  const [hasPendingRequest, setHasPendingRequest] = useState(false);
  let session;
  let broadcast;
  const subscriberRef = useRef(null);
  const publisherRef = useRef(null);
  const mainPanelRef = useRef(null);
  const subscriberArrayRef = useRef([]);
  const previousVideoBytesRate = useRef(0);
  const previousAudioBytesRate = useRef(0);
  const weakNetworkCount = useRef(0);
  const hasWarned = useRef(false);
  const toastId = `toast-${Date.now()}`;
  const [publisher, setPublisher] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [videoKbps, setVideoKbps] = useState();
  const [audioKbps, setAudioKbps] = useState();
  const [isScreenshareClicked, setIsScreenshareClicked] = useState(false);
  const [currentHost, setCurrentHost] = useState(1);
  const operationsInProgress = useRef(new Map());
  const broadcastStateCache = useRef({
    streams: [],
    lastUpdate: 0,
    cacheTimeout: 2000,
  });
  const [selectedLayout, setSelectedLayout] = useState();
  const mainPanelDivCheck = checkDivsInMainPanel();
  const [open, setOpen] = useState(false);
  const [showNotificationChat, setShowNotificationChat] = useState(false);
  const [networkStatus, setNetworkStatus] = useState(true);
  const [isDisconnected, setIsDisconnected] = useState(false);
  const [isLocalUserConnected, setIsLocalUserConnected] = useState(true);
  const [liveEventUrl, setLiveEventUrl] = useState('');
  const [isBroadcasting, setIsBroadcasting] = useState(false);
  const isFetchingStreamData = useRef(false);
  const currentLayout = sessionStorage.getItem('layoutSelected');
  const [activeController, setActiveController] = useState(() => {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const storedController = sessionStorage.getItem('activeController');

    if (isPrimaryHost() && !storedController) {
      sessionStorage.setItem('activeController', userData?.userId);
      return userData?.userId;
    }

    return storedController;
  });
  const [controlRequests, setControlRequests] = useState([]);
  const isProcessingAnyClick = useRef(false);
  const isReceivingLayoutSignal = useRef(false);
  const [showControlPanel, setShowControlPanel] = useState(true);

  const ControlPanel = () => {
    if (!canControlBroadcast() || !showControlPanel) return null;

    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const isController = activeController === userData?.userId;
    return (
      <div
        style={{
          position: "fixed",
          top: "10px",
          right: "10px",
          backgroundColor: "rgba(0,0,0,0.9)",
          padding: "12px",
          borderRadius: "8px",
          border: "1px solid #333",
          zIndex: 1000,
          minWidth: "200px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <span style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>
            Broadcast Control
          </span>
          <button
            onClick={() => setShowControlPanel(false)}
            style={{
              background: "none",
              border: "none",
              color: "#aaa",
              cursor: "pointer",
              fontSize: "16px",
              lineHeight: 1,
              padding: "0 2px",
            }}
            title="Close"
          >
            ✕
          </button>
        </div>

        {isPrimaryHost() && (
          <>
            <div
              style={{
                color: "#4CAF50",
                fontSize: "12px",
                marginBottom: "8px",
              }}
            >
              Status: {isController ? "You have control" : "Control delegated"}
            </div>

            {controlRequests.length > 0 && (
              <div style={{ marginBottom: "8px" }}>
                <div
                  style={{
                    color: "#ffa726",
                    fontSize: "12px",
                    marginBottom: "4px",
                  }}
                >
                  Requests ({controlRequests.length}):
                </div>
                {controlRequests.map((request, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "4px",
                      padding: "4px",
                      backgroundColor: "rgba(255,255,255,0.1)",
                      borderRadius: "4px",
                    }}
                  >
                    <span style={{ color: "white", fontSize: "11px" }}>
                      {request.requesterName}
                    </span>
                    <button
                      onClick={() =>
                        grantControl(request.requesterId, request.requesterName)
                      }
                      style={{
                        padding: "2px 8px",
                        fontSize: "10px",
                        backgroundColor: "#4CAF50",
                        color: "white",
                        border: "none",
                        borderRadius: "3px",
                        cursor: "pointer",
                      }}
                    >
                      Grant
                    </button>
                  </div>
                ))}
              </div>
            )}

            {!isController && (
              <button
                onClick={revokeControl}
                style={{
                  width: "100%",
                  padding: "6px",
                  backgroundColor: "#ff6b6b",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                Take Control Back
              </button>
            )}
          </>
        )}

        {isCoHost() && (
          <>
            <div
              style={{
                color: isController ? "#4CAF50" : "#ffa726",
                fontSize: "12px",
                marginBottom: "8px",
              }}
            >
              Status: {isController ? "You have control" : "No control"}
            </div>

            {!isController ? (
              <button
                onClick={requestControl}
                disabled={hasPendingRequest}
                style={{
                  width: "100%",
                  padding: "6px",
                  backgroundColor: hasPendingRequest ? "#666" : "#2196F3",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: hasPendingRequest ? "not-allowed" : "pointer",
                  opacity: hasPendingRequest ? 0.6 : 1,
                }}
              >
                {hasPendingRequest ? "Request Pending..." : "Request Control"}
              </button>
            ) : (
              <button
                onClick={releaseControl}
                style={{
                  width: "100%",
                  padding: "6px",
                  backgroundColor: "#ff9800",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                Release Control
              </button>
            )}
          </>
        )}
      </div>
    );
  };
  // Initialize control system when broadcast starts
  const initializeControlSystem = () => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));

    if (isPrimaryHost()) {
      // Host automatically gets control when starting broadcast
      const currentController = sessionStorage.getItem("activeController");

      // Only set if not already set
      if (!currentController || currentController !== userData.userId) {
        setActiveController(userData.userId);
        sessionStorage.setItem("activeController", userData.userId);

        // Notify all users
        if (window.session) {
          window.session.signal({
            type: "control-assigned",
            data: JSON.stringify({
              controllerId: userData.userId,
              controllerName: userData.userName,
              timestamp: Date.now(),
            }),
          });
        }
      }
    }
  };

  // Request control (for co-hosts)
  const requestControl = () => {
    const userData = JSON.parse(sessionStorage.getItem("userData"));

    if (!isCoHost()) {
      toast.error("Only co-hosts can request control");
      return;
    }
    if (hasPendingRequest) {
      toast("Request already sent. Waiting for host response...");
      return;
    }
    if (window.session) {
      window.session.signal({
        type: "control-request",
        data: JSON.stringify({
          requesterId: userData.userId,
          requesterName: userData.name,
          timestamp: Date.now(),
        }),
      });
      setHasPendingRequest(true);
      toast("Control request sent to host");
    }
  };

  // Grant control (for primary host)
  const grantControl = (userId, userName) => {
    if (!isPrimaryHost()) {
      // toast.error("Only the primary host can grant control");
      return;
    }

    setActiveController(userId);
    sessionStorage.setItem("activeController", userId);

    if (window.session) {
      window.session.signal({
        type: "control-granted",
        data: JSON.stringify({
          controllerId: userId,
          controllerName: userName,
          grantedBy: JSON.parse(sessionStorage.getItem("userData")).userId,
          timestamp: Date.now(),
        }),
      });
    }

    toast.success(`Control granted to ${userName}`);
    setControlRequests([]);
  };

  // Revoke control (for primary host)
  const revokeControl = () => {
    if (!isPrimaryHost()) {
      toast.error("Only the primary host can revoke control");
      return;
    }

    const userData = JSON.parse(sessionStorage.getItem("userData"));
    setActiveController(userData.userId);
    sessionStorage.setItem("activeController", userData.userId);

    if (window.session) {
      window.session.signal({
        type: "control-revoked",
        data: JSON.stringify({
          revokedBy: userData.userId,
          timestamp: Date.now(),
        }),
      });
    }

    toast.success("Control taken back");
  };

  // Release control (for co-hosts)
  const releaseControl = () => {
    if (!isCoHost()) return;

    const userData = JSON.parse(sessionStorage.getItem("userData"));

    if (window.session) {
      window.session.signal({
        type: "control-released",
        data: JSON.stringify({
          releasedBy: userData.userId,
          timestamp: Date.now(),
        }),
      });
    }

    setHasPendingRequest(false);
    toast("Control released");
  };

  useEffect(() => {
    const checkForActiveBroadcast = async () => {
      const currentBroadcastId = sessionStorage.getItem('broadcastId');

      // Only check if user doesn't have broadcastId yet
      if (!currentBroadcastId && sessionId) {
        try {

          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/v2/livemeeting/session/${sessionId}/broadcast`
          );

          if (response.ok) {
            const data = await response.json();

            if (data.success && data.broadcastId) {
              console.log('Found active broadcast via API:', data.broadcastId);
              sessionStorage.setItem('broadcastId', data.broadcastId);
              setBroadcastId(data.broadcastId);
              setIsBroadcasting(true);

              // Also restore UI state
              sessionStorage.setItem('needsUIRestore', 'true');

              return;
            }
          }

        } catch (error) {
          console.error('Error checking for active broadcast:', error);
        }
      } else if (currentBroadcastId && sessionId) {
        console.log('User already has broadcastId - will restore UI after streams load');
        sessionStorage.setItem('needsUIRestore', 'true');
      }
    };

    if (sessionId) {
      // Delay to ensure session signals are fully set up
      const timeoutId = setTimeout(() => {
        checkForActiveBroadcast();
      }, 3000);

      return () => clearTimeout(timeoutId);
    }
  }, [sessionId, userPermission]);

  useEffect(() => {
    const needsRestore = sessionStorage.getItem('needsUIRestore');
    const broadcastId = sessionStorage.getItem('broadcastId');

    if (needsRestore === 'true' && broadcastId && subscriberArrayRef.current.length > 0) {
      console.log('Streams detected, preparing to restore UI...');

      const attemptRestoration = async (retryCount = 0, maxRetries = 5) => {
        const storedStreams = JSON.parse(sessionStorage.getItem('streams') || '[]');

        let allStreamsRendered = true;
        const missingStreams = [];

        for (const stream of storedStreams) {
          const streamDiv = document.getElementById(stream.id);
          if (!streamDiv) {
            allStreamsRendered = false;
            missingStreams.push(stream.id);
          }
        }

        const screenshareStream = subscriberArrayRef.current.find(
          sub => sub.stream && sub.stream.videoType === 'screen'
        );

        if (screenshareStream) {
          const screenshareDiv = document.getElementById(screenshareStream.id);
          if (!screenshareDiv) {
            allStreamsRendered = false;
            missingStreams.push(`screenshare-${screenshareStream.id}`);
          }
        }

        if (allStreamsRendered) {
          console.log('All streams rendered in DOM - restoring now');
          await restoreBroadcastUI(subscriberArrayRef, resetLeftPanelStyles, changeLayout, toast);
          sessionStorage.removeItem('needsUIRestore');
        } else if (retryCount < maxRetries) {
          console.log(`Not all streams rendered yet (missing: ${missingStreams.join(', ')}). Retry ${retryCount + 1}/${maxRetries}...`);
          setTimeout(() => attemptRestoration(retryCount + 1, maxRetries), 1000);
        } else {
          console.warn('Max retries reached - attempting restoration anyway');
          await restoreBroadcastUI(subscriberArrayRef, resetLeftPanelStyles, changeLayout, toast);
          sessionStorage.removeItem('needsUIRestore');
        }
      };

      setTimeout(() => attemptRestoration(), 2000);
    }
  }, [subscriberArrayRef.current.length, streams, broadcastId]);
  useEffect(() => {
    if (!window.session) return;

    // Handle control requests
    window.session.on("signal:control-request", (event) => {
      const data = JSON.parse(event.data);

      if (isPrimaryHost()) {
        setControlRequests((prev) => [...prev, data]);
        toast(`${data.requesterName} is requesting broadcast control`, {
          duration: 5000,
          icon: "🎛️",
        });
      }
    });

    // Handle control granted
    window.session.on("signal:control-granted", (event) => {
      const data = JSON.parse(event.data);
      const userData = JSON.parse(sessionStorage.getItem("userData"));

      setActiveController(data.controllerId);
      sessionStorage.setItem("activeController", data.controllerId);

      if (userData.userId === data.controllerId) {
        setHasPendingRequest(false);
        toast.success("You now have broadcast control!");
      } else {
        toast(`${data.controllerName} now has broadcast control`);
      }
    });

    // Handle control revoked
    window.session.on("signal:control-revoked", (event) => {
      const userData = JSON.parse(sessionStorage.getItem("userData"));
      const data = event.data ? JSON.parse(event.data) : {};

      if (isCoHost()) {
        setActiveController(null);
        sessionStorage.removeItem("activeController");
        setHasPendingRequest(false);

        const message = data.reason === 'host_rejoined'
          ? "Host has rejoined and taken back control"
          : "Host has taken back control";

        toast(message, { icon: "🔒" });
      }
    });

    // Handle control released
    window.session.on("signal:control-released", (event) => {
      const userData = JSON.parse(sessionStorage.getItem("userData"));

      if (isPrimaryHost()) {
        setActiveController(userData.userId);
        sessionStorage.setItem("activeController", userData.userId);
        toast("Control has been released - You now have control");
      } else {
        setActiveController(null);
        sessionStorage.removeItem("activeController");
      }

      setHasPendingRequest(false);

      if (!isPrimaryHost()) {
        toast("Broadcast control has been released");
      }
    });

    // Handle control assignment (initial)
    window.session.on("signal:control-assigned", (event) => {
      const data = JSON.parse(event.data);
      setActiveController(data.controllerId);
      sessionStorage.setItem("activeController", data.controllerId);
    });

    return () => {
      window.session.off("signal:control-request");
      window.session.off("signal:control-granted");
      window.session.off("signal:control-revoked");
      window.session.off("signal:control-released");
      window.session.off("signal:control-assigned");
    };
  }, [window.session]);

  const getBroadcastState = async (forceRefresh = false) => {
    const now = Date.now();
    const cache = broadcastStateCache.current;

    if (!forceRefresh && now - cache.lastUpdate < cache.cacheTimeout) {
      return cache.streams;
    }

    try {
      const broadcastId = sessionStorage.getItem('broadcastId');
      if (!broadcastId) return [];

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/status/${broadcastId}`,
        { method: 'POST' }
      );

      if (!response.ok) return cache.streams;

      const result = await response.json();
      const streamIds = result?.streams?.map((s) => s.streamId) || [];

      broadcastStateCache.current = {
        streams: streamIds,
        lastUpdate: now,
        cacheTimeout: 2000,
      };

      return streamIds;
    } catch (error) {
      console.error('Failed to get broadcast state:', error);
      return cache.streams;
    }
  };

  const fetchMediaChannelStatus = async () => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      if (!userData?.token) {
        console.error('No auth token found');
        return 'Unknown';
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livestream/mediachannelstatus`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userData.token}`,
            Accept: 'application/json, text/plain, */*',
          },
          body: JSON.stringify({ videoId: pid }),
        }
      );

      if (!response.ok) {
        throw new Error(`Status request failed: ${response.status}`);
      }

      const result = await response.json();
      if (result?.result?.primaryChannelStatus) {
        setMediaChannelStatus(result.result.primaryChannelStatus);
        return result.result.primaryChannelStatus;
      }

      return 'Unknown';
    } catch (err) {
      console.error('Failed to fetch media channel status:', err);
      setMediaChannelStatus('Unknown');
      return 'Unknown';
    }
  };

  const pushStreamsToLiveSection = () => {
    const liveStreams =
      JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
    const storedStreams = JSON.parse(sessionStorage.getItem('streams')) || [];

    const mainPanel = document.querySelector('.main-panel');
    if (!mainPanel) return;

    liveStreams.forEach((liveStream) => {
      if (!liveStream.inLive) return;
      const matchingStream = storedStreams.find(
        (stream) => stream.streamId === liveStream.streamId
      );
      if (
        matchingStream &&
        subscriberArrayRef.current.some(
          (sub) => sub.streamId === liveStream.streamId
        )
      ) {
        const streamDiv = document.getElementById(matchingStream.id);
        if (streamDiv && !mainPanel.contains(streamDiv)) {
          mainPanel.appendChild(streamDiv);
          streamDiv.classList.add('highlight-border');
        }
      }
    });

    // Clean up stale streams
    let validStreams = storedStreams.filter((stream) =>
      subscriberArrayRef.current.some((sub) => sub.streamId === stream.streamId)
    );
    sessionStorage.setItem('streams', JSON.stringify(validStreams));

    if (sessionStorage.getItem('isScreenshareInLive') === 'true') {
      const screenshareDiv = document.getElementById('hls-screen-shares');
      if (
        screenshareDiv &&
        streamData?.response?.some((item) => item.videoType === 'screen')
      ) {
        if (!mainPanel.contains(screenshareDiv)) {
          mainPanel.appendChild(screenshareDiv);
          if (checkDivsInMainPanel().otDivCount === 0) {
            screenshareDiv.style.height = '90%';
          }
        }
      } else {
        sessionStorage.setItem('isScreenshareInLive', false);
      }
    }
    changeLayout(sessionStorage.getItem('layoutSelected') || 'bestFit');
  };

  useEffect(() => {
    if (window.session) {
      // Detect if the user loses connection due to a network issue
      window.session.on('sessionDisconnected', (event) => {
        if (event.reason === 'networkDisconnected' && !isDisconnected) {
          toast.error(
            'You have lost connection to the livestream. Please check your network.'
          );
          setIsLocalUserConnected(false);
          setIsDisconnected(true);
        }
      });

      // Detect if the user reconnects after losing internet
      window.session.on('connectionCreated', (event) => {
        if (
          event.connection.connectionId ===
          window.session.connection?.connectionId
        ) {
          setIsLocalUserConnected(true);
          if (isDisconnected) {
            setIsDisconnected(false);
          }
        }
      });
    }
  }, [isDisconnected]);

  // Periodic UI reconciliation for non-host users
  useEffect(() => {
    if (isPrimaryHost()) return;

    const reconcileUIWithBroadcastState = async () => {
      const broadcastId = sessionStorage.getItem('broadcastId');
      if (!broadcastId) return;

      const storedStreams = JSON.parse(sessionStorage.getItem('streams') || '[]');
      if (storedStreams.length === 0 && subscriberArrayRef.current.length === 0) return;

      if (operationsInProgress.current.size > 0 || isProcessingAnyClick.current) return;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/status/${broadcastId}`,
          { method: 'POST' }
        );
        if (!response.ok) return;

        const result = await response.json();
        const liveBroadcastStreamIds = (result?.streams || []).map(s => s.streamId);

        const mainPanel = document.getElementById('main-panel');
        if (!mainPanel) return;

        let streamsInLive = JSON.parse(sessionStorage.getItem('streamsInLive') || '[]');
        let stateChanged = false;

        // Reconcile regular camera streams 
        for (const stored of storedStreams) {
          if (!stored.streamId || !stored.id) continue;

          // Skip the screenshare container — handled separately 
          if (stored.id === 'hls-screen-shares') continue;

          const streamDiv = document.getElementById(stored.id);
          if (!streamDiv) continue;

          const hlsScreenSharesDiv = document.getElementById('hls-screen-shares');
          if (hlsScreenSharesDiv && hlsScreenSharesDiv.contains(streamDiv)) continue;

          if (!stored.id.startsWith('OT_')) continue;

          const shouldBeInLive = liveBroadcastStreamIds.includes(stored.streamId);
          const isInMainPanel = mainPanel.contains(streamDiv);

          if (shouldBeInLive && !isInMainPanel) {
            console.log('[Reconcile] Moving stream to live stage:', stored.id,
              '| isScreenshare:', subscriberArrayRef.current.find(
                s => s.streamId === stored.streamId
              )?.stream?.videoType === 'screen'
            );
            mainPanel.appendChild(streamDiv);
            streamDiv.classList.add('highlight-border');

            const idx = streamsInLive.findIndex(s => s.streamId === stored.streamId);
            if (idx === -1) streamsInLive.push({ streamId: stored.streamId, inLive: true });
            else streamsInLive[idx].inLive = true;
            stateChanged = true;

          } else if (!shouldBeInLive && isInMainPanel) {
            console.log('[Reconcile] Moving stream to backstage:', stored.id,
              '| isScreenshare:', subscriberArrayRef.current.find(
                s => s.streamId === stored.streamId
              )?.stream?.videoType === 'screen'
            );

            const sub = subscriberArrayRef.current.find(
              s => s.streamId === stored.streamId
            );
            const isScreenshareStream = sub?.stream?.videoType === 'screen';

            let originalContainer;
            if (isScreenshareStream) {
              originalContainer = 'subscribers';
            } else {
              originalContainer =
                streamDiv.getAttribute('data-original-container') || 'subscribers';
            }

            const targetContainer =
              document.getElementById(originalContainer) ||
              document.querySelector('.left-panel');

            if (targetContainer) {
              targetContainer.appendChild(streamDiv);
              streamDiv.classList.remove('highlight-border');
            }

            const idx = streamsInLive.findIndex(s => s.streamId === stored.streamId);
            if (idx !== -1) streamsInLive[idx].inLive = false;
            stateChanged = true;
          }
        }

        //Reconcile screenshare
        const screenshareStream = subscriberArrayRef.current.find(
          sub => sub?.stream?.videoType === 'screen'
        );

        if (screenshareStream?.streamId) {
          const screenshareStreamId = screenshareStream.streamId;
          const screenshareDiv = document.getElementById('hls-screen-shares');

          if (screenshareDiv) {
            const shouldBeInLive = liveBroadcastStreamIds.includes(screenshareStreamId);
            const isInMainPanel = mainPanel.contains(screenshareDiv);

            if (shouldBeInLive && !isInMainPanel) {
              console.log('[Reconcile] Moving screenshare to live stage');
              mainPanel.appendChild(screenshareDiv);
              screenshareDiv.classList.add('highlight-border');

              // If no other OT camera divs in main panel, give screenshare full height
              const otDivCount = Array.from(mainPanel.querySelectorAll('[id^="OT_"]'))
                .filter(d => !screenshareDiv.contains(d)).length;
              if (otDivCount === 0) {
                screenshareDiv.style.height = '90%';
                screenshareDiv.style.width = '100%';
              }

              sessionStorage.setItem('isScreenshareInLive', 'true');

              const idx = streamsInLive.findIndex(s => s.streamId === screenshareStreamId);
              if (idx === -1) streamsInLive.push({ streamId: screenshareStreamId, inLive: true });
              else streamsInLive[idx].inLive = true;
              stateChanged = true;

            } else if (!shouldBeInLive && isInMainPanel) {
              console.log('[Reconcile] Moving screenshare to backstage');

              screenshareDiv.classList.remove('highlight-border');
              screenshareDiv.style.height = '25%';
              screenshareDiv.style.width = '100%';

              // Restore to correct position in left panel:
              // between publishers and subscribers, same as original placement
              const publishersDiv = document.getElementById('publishers');
              const backstageButtonDiv = document.getElementById('backstage-button');
              const subscribersDiv = document.getElementById('subscribers');

              if (publishersDiv && subscribersDiv) {
                publishersDiv.insertAdjacentElement('afterend', screenshareDiv);
              } else if (backstageButtonDiv) {
                backstageButtonDiv.insertAdjacentElement('afterend', screenshareDiv);
              } else {
                const leftPanel = document.querySelector('.left-panel');
                if (leftPanel) leftPanel.appendChild(screenshareDiv);
              }

              sessionStorage.setItem('isScreenshareInLive', 'false');

              const idx = streamsInLive.findIndex(s => s.streamId === screenshareStreamId);
              if (idx !== -1) streamsInLive[idx].inLive = false;
              stateChanged = true;
            }
          }
        }

        if (stateChanged) {
          sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));
          resetLeftPanelStyles();
          changeLayout(sessionStorage.getItem('layoutSelected') || 'bestFit');
          console.log('[Reconcile] UI reconciled with broadcast state');
        }

      } catch (err) {
        console.error('[Reconcile] Error during UI reconciliation:', err);
      }
    };

    const reconcileInterval = setInterval(reconcileUIWithBroadcastState, 5000);
    const initialTimeout = setTimeout(reconcileUIWithBroadcastState, 3000);

    return () => {
      clearInterval(reconcileInterval);
      clearTimeout(initialTimeout);
    };
  }, [sessionId, subscriberArrayRef.current.length]);
  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const fetchPermissions = async () => {
      await checkCanControl(pid, userData.userId);
    };
    fetchPermissions();
    if (window.session?.connection && isPrimaryHost()) {
      setTimeout(() => {
        initializeControlSystem();
      }, 100);
    }
  }, [pid, window.session]);
  useEffect(() => {
    if (!window.session) return;

    const handleSessionConnected = () => {
      const userData = JSON.parse(sessionStorage.getItem('userData'));

      if (isPrimaryHost()) {
        // Ensure host has control after connection
        const currentController = sessionStorage.getItem('activeController');
        if (!currentController) {
          setActiveController(userData.userId);
          sessionStorage.setItem('activeController', userData.userId);
        }
      }
    };

    window.session.on('sessionConnected', handleSessionConnected);

    return () => {
      window.session.off('sessionConnected', handleSessionConnected);
    };
  }, [window.session]);
  useEffect(() => {
    const checkInternetConnection = () => {
      if (!navigator.onLine && networkStatus) {
        if (!isDisconnected) {
          toast.error('You have lost internet connection.');
          setIsDisconnected(true);
          setIsLocalUserConnected(false);
        }
        setNetworkStatus(false);
      } else if (navigator.onLine && !networkStatus) {
        setNetworkStatus(true);

        setTimeout(() => {
          if (!window.session?.connection) {
            console.log(
              'Session not connected, keeping reconnect button visible.'
            );
          } else {
            console.log('Session is connected, hiding reconnect button.');
            setIsDisconnected(false);
            setIsLocalUserConnected(true);
          }
        }, 5000);
      }
    };

    window.addEventListener('offline', checkInternetConnection);
    window.addEventListener('online', checkInternetConnection);

    return () => {
      window.removeEventListener('offline', checkInternetConnection);
      window.removeEventListener('online', checkInternetConnection);
    };
  }, [networkStatus, isDisconnected]);

  const handleReconnect = async () => {
    if (!navigator.onLine) {
      toast.error(
        'No internet connection. Please try again after reconnecting.'
      );
      return;
    }

    if (window.session?.connection) {
      console.log('Session is already connected. No need to reconnect.');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/session/${pid}/${userName}/${userId}/${roleName}`
      );
      const res = await response.json();

      if (res.apiKey && res.sessionId && res.token) {
        console.log('Reconnecting session...');
        initializeSession(res.apiKey, res.sessionId, res.token);
        toast.success('Reconnecting...');

        window.session.on('sessionConnected', () => {
          console.log('Session reconnected successfully!');

          setTimeout(() => {

            if (window.publisher) {
              console.log('Unpublishing and destroying existing publisher...');
              window.session.unpublish(window.publisher);
              window.publisher.destroy();
              window.publisher = null;
            }

            console.log('Creating new publisher...');
            window.publisher = window.OT.initPublisher(
              'publishers',
              {
                insertMode: 'append',
                width: '100%',
                height: '100%',
                resolution: '1280x720',
                publishAudio: true,
                publishVideo: true,
                audioFallback: {
                  publisher: true,
                },
              },
              (error) => {
                if (error) {
                  console.error('Failed to initialize new publisher:', error);
                  toast.error('Failed to initialize new camera stream.');
                  return;
                }

                console.log('New publisher initialized, attaching events...');

                // Attach event listeners to the new publisher
                window.publisher.on('streamCreated', () => {
                  console.log('Stream created event triggered.');
                  setPublisher(window.publisher);
                });

                window.publisher.on('streamDestroyed', () => {
                  console.log('Stream destroyed event triggered.');
                });

                // Publish camera again
                console.log('Publishing camera to session...');
                window.session.publish(window.publisher, (error) => {
                  if (error) {
                    console.error('Failed to republish:', error);
                    toast.error('Failed to restart camera stream.');
                  } else {
                    toast.success('Camera stream restarted successfully.');

                    // Ensure toolbar functionalities work
                    setPublisher(window.publisher);

                    // Ensure old publishers are removed from subscriberArrayRef
                    subscriberArrayRef.current =
                      subscriberArrayRef.current.filter(
                        (sub) => sub.streamId !== window.publisher.streamId
                      );

                    // Now add the new publisher
                    subscriberArrayRef.current.push(window.publisher);
                    setStreams(subscriberArrayRef.current);
                  }
                });
              }
            );
          }, 3000);
        });

        setTimeout(() => {
          setIsLocalUserConnected(true);
          setIsDisconnected(false);
        }, 5000);
      } else {
        toast.error('Failed to reconnect. Please refresh the page.');
      }
    } catch (error) {
      console.error('Reconnect failed:', error);
      toast.error('Reconnect failed. Please try again.');
    }
  };

  const checkBroadcastStatus = async (broadcastId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/status/${broadcastId}`,
        { method: 'POST' }
      );

      if (!response.ok) {
        throw new Error(
          `Status check failed: ${response.status} ${response.statusText}`
        );
      }

      const result = await response.json();
      setMediaChannelStatus(result.mediaChannelStatus || 'Unknown');

      // Check for error conditions
      if (result.error || result.mediaChannelStatus === 'ERROR') {
        setBroadcastError({
          type: 'BROADCAST_STATUS_ERROR',
          message: result.error?.message || 'Media channel error detected',
          details:
            result.error?.details ||
            `Channel status: ${result.mediaChannelStatus}`,
          mediaChannelStatus: result.mediaChannelStatus,
          timestamp: new Date().toISOString(),
          canRetry: true,
        });
        setShowErrorModal(true);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Status check failed:', error);
      return false;
    }
  };

  const checkAWSRTMP = async (retryCount = 5) => {
    try {
      const broadcastId = sessionStorage.getItem('broadcastId');
      if (!broadcastId) return;

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/status/${broadcastId}`,
        { method: 'POST' }
      );

      if (!response.ok) {
        throw new Error(`RTMP check failed: ${response.status}`);
      }

      const result = await response.json();

      if (result?.broadcastUrls?.rtmp?.[0]?.status === 'failed') {
        if (retryCount > 0) {
          console.warn(`RTMP failed. Retrying... (${5 - retryCount + 1}/5)`);
          setTimeout(() => checkAWSRTMP(retryCount - 1), 5000);
        } else {
          setBroadcastError({
            type: 'RTMP_PERSISTENT_ERROR',
            message: 'RTMP stream consistently failing',
            details: 'Multiple attempts to establish RTMP connection failed',
            mediaChannelStatus: result.mediaChannelStatus || 'Unknown',
            timestamp: new Date().toISOString(),
            canRetry: true,
          });
          setShowErrorModal(true);
        }
      }
    } catch (error) {
      console.error('AWS RTMP check failed:', error);
      setBroadcastError({
        type: 'RTMP_CHECK_ERROR',
        message: 'Failed to check RTMP status',
        details: error.message,
        mediaChannelStatus: 'Unknown',
        timestamp: new Date().toISOString(),
        canRetry: true,
      });
      setShowErrorModal(true);
    }
  };

  const syncBroadcastState = async (forceUIUpdate = false) => {
    const broadcastId = sessionStorage.getItem('broadcastId');
    if (!broadcastId) return;

    if (!forceUIUpdate && operationsInProgress.current.size > 0) {
      console.log('Skipping sync - operations in progress');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/status/${broadcastId}`,
        { method: 'POST' }
      );
      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Failed to fetch broadcast status');
      }

      const broadcastStreams = result?.streams || [];
      const broadcastStreamIds = broadcastStreams.map(
        (stream) => stream.streamId
      );

      broadcastStateCache.current = {
        streams: broadcastStreamIds,
        lastUpdate: Date.now(),
        cacheTimeout: 2000,
      };

      let streamsInLive =
        JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
      let storedStreams = JSON.parse(sessionStorage.getItem('streams')) || [];

      const sessionStreamIds = subscriberArrayRef.current
        .filter((sub) => sub?.streamId)
        .map((sub) => sub.streamId);

      subscriberArrayRef.current = subscriberArrayRef.current.filter(
        (sub) => sub?.streamId && sessionStreamIds.includes(sub.streamId)
      );
      setStreams(subscriberArrayRef.current);

      streamsInLive = streamsInLive
        .map((stream) => {
          if (
            !broadcastStreamIds.includes(stream.streamId) &&
            sessionStreamIds.includes(stream.streamId)
          ) {
            return stream;
          }

          if (!sessionStreamIds.includes(stream.streamId)) {
            return { ...stream, inLive: false };
          }
          return stream;
        })
        .filter((stream) => sessionStreamIds.includes(stream.streamId));

      storedStreams = storedStreams.filter((stream) =>
        subscriberArrayRef.current.some(
          (sub) => sub.streamId === stream.streamId
        )
      );

      sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));
      sessionStorage.setItem('streams', JSON.stringify(storedStreams));

      const mainPanel = document.getElementById('main-panel');
      if (!mainPanel) return;

      const liveStreams = streamsInLive.filter((stream) => stream.inLive);
      const liveStreamIds = liveStreams
        .map((stream) => {
          const matchingStream = storedStreams.find(
            (s) => s.streamId === stream.streamId
          );
          return matchingStream?.id;
        })
        .filter((id) => id);

      liveStreamIds.forEach((id) => {
        const streamDiv = document.getElementById(id);
        if (streamDiv && !mainPanel.contains(streamDiv)) {
          console.log('Moving stream to main panel:', id);
          mainPanel.appendChild(streamDiv);
          streamDiv.classList.add('highlight-border');
        }
      });

      const allStreamDivs = Array.from(
        mainPanel.querySelectorAll('[id^="OT_"]')
      );
      allStreamDivs.forEach((div) => {
        const streamInLive = streamsInLive.find((s) => {
          const stored = storedStreams.find((st) => st.id === div.id);
          return stored && s.streamId === stored.streamId;
        });

        if (streamInLive && streamInLive.inLive === false) {
          const originalContainer =
            div.getAttribute('data-original-container') || 'subscribers';
          const targetContainer =
            document.getElementById(originalContainer) ||
            document.querySelector('.left-panel');
          if (targetContainer && !targetContainer.contains(div)) {
            console.log('Moving stream to backstage:', div.id);
            targetContainer.appendChild(div);
            div.classList.remove('highlight-border');
          }
        }
      });

      if (sessionStorage.getItem('isScreenshareInLive') === 'true') {
        const screenshareDiv = document.getElementById('hls-screen-shares');
        let screenshareId;
        streamData?.response?.forEach((item) => {
          if (item.videoType === 'screen') {
            screenshareId = item.id;
          }
        });
        if (screenshareDiv && broadcastStreamIds.includes(screenshareId)) {
          if (!mainPanel.contains(screenshareDiv)) {
            mainPanel.appendChild(screenshareDiv);
            if (checkDivsInMainPanel().otDivCount === 0) {
              screenshareDiv.style.height = '90%';
            }
          }
        } else if (
          screenshareId &&
          !broadcastStreamIds.includes(screenshareId)
        ) {
          sessionStorage.setItem('isScreenshareInLive', 'false');
        }
      }

      resetLeftPanelStyles();
      const currentLayout = sessionStorage.getItem('layoutSelected');
      changeLayout(currentLayout || 'bestFit');
    } catch (error) {
      console.error('Failed to sync broadcast state:', error);
    }
  };

  useEffect(() => {
    const handleDynamicDivClick = async (event) => {
      if (event.target.closest('.OT_mute')) return;

      const broadcastId = sessionStorage.getItem('broadcastId');

      if (!canControlBroadcast()) {
        toast.error('Only Host or Co-Host can manage sources');
        return;
      }

      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const currentController = sessionStorage.getItem('activeController');

      if (!currentController || currentController !== userData.userId) {
        if (isCoHost()) {
          toast.error('You need to request control from the host first');
        } else {
          toast.error('Another user currently has broadcast control');
        }
        return;
      }

      if (!broadcastId) {
        toast.error(
          'Sources can only be added to LIVE STAGE once you Go Live.'
        );
        return;
      }

      const lastClickTime = parseInt(
        sessionStorage.getItem('lastStreamClickTime') || '0'
      );
      const now = Date.now();
      if (now - lastClickTime < 2000) {
        toast('Please wait before the next operation');
        return;
      }
      sessionStorage.setItem('lastStreamClickTime', now.toString());

      if (isProcessingAnyClick.current) {
        toast('Please wait, processing previous stream...');
        return;
      }

      const mainPanel = document.getElementById('main-panel');
      const clickedDynamicDiv = event.target.closest("[id^='OT_']");

      if (!clickedDynamicDiv) return;

      const dynamicId = clickedDynamicDiv.id;

      refreshSubscriberArray();

      const sub = subscriberArrayRef.current.find((s) => s.id === dynamicId);

      if (!sub?.streamId) {
        toast.error('Invalid stream - stream may have disconnected');

        if (clickedDynamicDiv.parentElement) {
          clickedDynamicDiv.remove();
        }
        syncBroadcastState();
        return;
      }

      if (!validateStreamExists(sub.streamId)) {
        toast.error('Stream no longer active');

        subscriberArrayRef.current = subscriberArrayRef.current.filter(
          (s) => s.streamId !== sub.streamId
        );
        if (clickedDynamicDiv.parentElement) {
          clickedDynamicDiv.remove();
        }
        syncBroadcastState();
        return;
      }

      if (operationsInProgress.current.has(sub.streamId)) {
        toast('This stream is already being processed...');
        return;
      }

      const otDivs = Array.from(mainPanel.querySelectorAll('div')).filter(
        (div) =>
          div.id &&
          div.id.startsWith('OT') &&
          !div.closest('#hls-screen-shares')
      );
      const isScreenShareInMain =
        !!document.getElementById('hls-screen-shares') &&
        mainPanel.contains(document.getElementById('hls-screen-shares'));
      const currentPresentersCount =
        otDivs.length + (isScreenShareInMain ? 1 : 0);
      const isInMainPanel = mainPanel.contains(clickedDynamicDiv);

      if (!isInMainPanel && currentPresentersCount >= 6) {
        toast.error('Maximum 6 sources allowed on screen at once.');
        return;
      }

      const layoutSelected = sessionStorage.getItem('layoutSelected');
      const isPipOrCustomLayout =
        layoutSelected === 'pip' || layoutSelected === 'custom';

      if (!isInMainPanel && isPipOrCustomLayout && otDivs.length >= 1) {
        toast.error("Can't add more than one speaker to the selected layout.");
        return;
      }

      isProcessingAnyClick.current = true;
      operationsInProgress.current.set(sub.streamId, true);

      const action = isInMainPanel ? 'removeStream' : 'addStream';

      document.querySelectorAll('[id^="OT_"]').forEach((div) => {
        div.style.pointerEvents = 'none';
      });
      document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
        div.style.pointerEvents = 'none';
      });

      let toastId = toast.loading('Processing...');

      const timeoutId = setTimeout(() => {
        toast.error('Operation timed out', { id: toastId });
        operationsInProgress.current.delete(sub.streamId);
        isProcessingAnyClick.current = false;
        document.querySelectorAll('[id^="OT_"]').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });
        document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });
        syncBroadcastState();
      }, 15000);

      try {
        if (!validateStreamExists(sub.streamId)) {
          throw new Error('Stream disconnected during operation');
        }

        const currentBroadcastStreams = await getBroadcastState(true);
        const isCurrentlyInBroadcast = currentBroadcastStreams.includes(
          sub.streamId
        );

        if (action === 'removeStream' && !isCurrentlyInBroadcast) {
          toast.error('Stream already removed from broadcast', { id: toastId });

          let streamsInLive =
            JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
          const streamIndex = streamsInLive.findIndex(
            (item) => item.streamId === sub.streamId
          );
          if (streamIndex !== -1) {
            streamsInLive[streamIndex].inLive = false;
            sessionStorage.setItem(
              'streamsInLive',
              JSON.stringify(streamsInLive)
            );
          }

          let originalContainer = clickedDynamicDiv.getAttribute(
            'data-original-container'
          );

          if (!originalContainer) {
            if (
              window.publisher &&
              clickedDynamicDiv.id === window.publisher.id
            ) {
              originalContainer = 'publishers';
            } else {
              originalContainer = 'subscribers';
            }

            clickedDynamicDiv.setAttribute(
              'data-original-container',
              originalContainer
            );
          }

          const targetContainer =
            document.getElementById(originalContainer) ||
            document.querySelector('.left-panel');

          if (targetContainer) {
            targetContainer.appendChild(clickedDynamicDiv);
            clickedDynamicDiv.classList.remove('highlight-border');
          }

          resetLeftPanelStyles();
          changeLayout(sessionStorage.getItem('layoutSelected'));
          return;
        }

        if (action === 'addStream' && isCurrentlyInBroadcast) {
          toast.error('Stream already in broadcast', { id: toastId });

          let streamsInLive =
            JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
          const streamIndex = streamsInLive.findIndex(
            (item) => item.streamId === sub.streamId
          );
          if (streamIndex === -1) {
            streamsInLive.push({ streamId: sub.streamId, inLive: true });
          } else {
            streamsInLive[streamIndex].inLive = true;
          }
          sessionStorage.setItem(
            'streamsInLive',
            JSON.stringify(streamsInLive)
          );

          if (!mainPanel.contains(clickedDynamicDiv)) {
            mainPanel.appendChild(clickedDynamicDiv);
            clickedDynamicDiv.classList.add('highlight-border');
          }

          resetLeftPanelStyles();
          changeLayout(sessionStorage.getItem('layoutSelected'));
          return;
        }

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/${action}/${broadcastId}/${sub.streamId}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
          }
        );

        const result = await response.json();

        if (!response.ok) {
          if (result.message && result.message.includes('invalid stream')) {
            throw new Error(
              'Stream is no longer valid - it may have disconnected'
            );
          }
          throw new Error(result.message || `Failed to ${action}`);
        }

        await new Promise((resolve) => setTimeout(resolve, 800));
        const verifiedBroadcastStreams = await getBroadcastState(true);
        const operationSucceeded =
          action === 'addStream'
            ? verifiedBroadcastStreams.includes(sub.streamId)
            : !verifiedBroadcastStreams.includes(sub.streamId);

        if (!operationSucceeded) {
          throw new Error('Operation reported success but state unchanged');
        }

        toast.success(
          `Source ${action === 'addStream' ? 'Added.' : 'Removed.'}`,
          { id: toastId }
        );
        broadcastStateCache.current = {
          streams: verifiedBroadcastStreams,
          lastUpdate: Date.now(),
          cacheTimeout: 2000,
        };

        let streamsInLive =
          JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
        const streamIndex = streamsInLive.findIndex(
          (item) => item.streamId === sub.streamId
        );

        if (action === 'addStream') {
          if (streamIndex === -1) {
            streamsInLive.push({ streamId: sub.streamId, inLive: true });
          } else {
            streamsInLive[streamIndex].inLive = true;
          }
        } else {
          if (streamIndex !== -1) {
            streamsInLive[streamIndex].inLive = false;
          }
        }
        sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));

        let originalContainer = clickedDynamicDiv.getAttribute(
          'data-original-container'
        );

        if (!originalContainer) {
          if (
            window.publisher &&
            clickedDynamicDiv.id === window.publisher.id
          ) {
            originalContainer = 'publishers';
          } else {
            originalContainer = 'subscribers';
          }
        }

        clickedDynamicDiv.setAttribute(
          'data-original-container',
          originalContainer
        );

        if (action === 'addStream') {
          mainPanel.appendChild(clickedDynamicDiv);
          clickedDynamicDiv.classList.add('highlight-border');
        } else {
          const targetContainer =
            document.getElementById(originalContainer) ||
            document.querySelector('.left-panel');
          if (targetContainer) {
            targetContainer.appendChild(clickedDynamicDiv);
            clickedDynamicDiv.classList.remove('highlight-border');
          }
        }

        resetLeftPanelStyles();
        handleStreamPushed(sub.streamId, action, originalContainer);
        changeLayout(sessionStorage.getItem('layoutSelected'));
      } catch (error) {
        console.error(`Failed to ${action}:`, error);
        if (
          error.message.includes('already removed') ||
          error.message.includes('invalid stream id')
        ) {
          console.warn(
            'Stream already processed by another client, syncing...'
          );
          toast.dismiss(toastId);

          await syncBroadcastState();

          clearTimeout(timeoutId);
          operationsInProgress.current.delete(sub.streamId);
          isProcessingAnyClick.current = false;
          document.querySelectorAll('[id^="OT_"]').forEach((div) => {
            div.style.pointerEvents = 'auto';
          });
          document
            .querySelectorAll('#hls-screen-shares > div')
            .forEach((div) => {
              div.style.pointerEvents = 'auto';
            });
          return;
        }

        if (
          error.message.includes('disconnected') ||
          error.message.includes('no longer valid')
        ) {
          toast.error('Stream has disconnected', { id: toastId });

          // Clean up disconnected stream
          subscriberArrayRef.current = subscriberArrayRef.current.filter(
            (s) => s.streamId !== sub.streamId
          );

          let streamsInLive =
            JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
          streamsInLive = streamsInLive.filter(
            (s) => s.streamId !== sub.streamId
          );
          sessionStorage.setItem(
            'streamsInLive',
            JSON.stringify(streamsInLive)
          );

          let storedStreams =
            JSON.parse(sessionStorage.getItem('streams')) || [];
          storedStreams = storedStreams.filter(
            (s) => s.streamId !== sub.streamId
          );
          sessionStorage.setItem('streams', JSON.stringify(storedStreams));

          // Remove from DOM
          if (clickedDynamicDiv.parentElement) {
            clickedDynamicDiv.remove();
          }
        } else {
          toast.error(
            `Failed to ${action === 'addStream' ? 'add' : 'remove'} stream: ${error.message
            }`,
            { id: toastId }
          );
        }

        setTimeout(() => syncBroadcastState(), 1000);
      } finally {
        clearTimeout(timeoutId);
        operationsInProgress.current.delete(sub.streamId);
        isProcessingAnyClick.current = false;

        document.querySelectorAll('[id^="OT_"]').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });
        document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });
      }
    };

    // Attach the event listener to the parent divs
    const subscriberDiv = subscriberRef.current;
    if (subscriberDiv) {
      subscriberDiv.addEventListener('click', handleDynamicDivClick);
    }

    const publisherDiv = publisherRef.current;
    if (publisherDiv) {
      publisherDiv.addEventListener('click', handleDynamicDivClick);
    }

    const mainPanel = document.getElementById('main-panel');
    if (mainPanel) {
      mainPanel.addEventListener('click', handleDynamicDivClick);
    }

    // Clean up event listeners on component unmount
    return () => {
      if (subscriberDiv) {
        subscriberDiv.removeEventListener('click', handleDynamicDivClick);
      }
      if (publisherDiv) {
        publisherDiv.removeEventListener('click', handleDynamicDivClick);
      }
      if (mainPanel) {
        mainPanel.removeEventListener('click', handleDynamicDivClick);
      }
    };
  }, []);

  useEffect(() => {
    if (publisher !== null) {
      setIsLoading(false);
    }
  }, [publisher]);

  const handleStreamPushed = async (
    streamId,
    action,
    originalContainer,
    retryCount = 3
  ) => {
    if (!window.session) {
      console.error('Session not available for signaling');
      return;
    }

    const signalData = JSON.stringify({
      streamId,
      action,
      originalContainer,
      timestamp: Date.now(),
    });

    try {
      await window.session.signal({
        type: 'stream-pushed',
        data: signalData,
      });
      console.log(`Stream ${streamId} ${action} signal sent successfully`);

      // Verify the signal was processed
      await new Promise((resolve) => setTimeout(resolve, 500));
      changeLayout(sessionStorage.getItem('layoutSelected'));
    } catch (error) {
      console.error('Failed to send stream signal:', error);

      if (retryCount > 0) {
        console.log(`Retrying to send signal... (${3 - retryCount + 1}/3)`);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return handleStreamPushed(
          streamId,
          action,
          originalContainer,
          retryCount - 1
        );
      } else {
        toast.error('Failed to sync stream across hosts. Forcing sync...');
        setTimeout(() => syncBroadcastState(), 2000);
      }
    }
  };

  const postSessionId = async (sessionId) => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/v2/video/media/livemeeting/session/${pid}`,
        {
          sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        }
      );
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    if (!session) {
      fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/session/${pid}/${userName}/${userId}/${roleName}`,
        {
          method: 'GET',
        }
      )
        .then((res) => res.json())
        .then((res) => {
          postSessionId(res.sessionId);
          setSessionId(res.sessionId);
          sessionStorage.setItem('sessionId', res.sessionId);
          const apiKey = res.apiKey;
          const sessionId = res.sessionId;
          const token = res.token;
          initializeSession(apiKey, sessionId, token);
        })
        .catch(handleCallback);
    }
  }, [pid, roleName, userName, userId]);

  const initializeSession = (apiKey, sessionId, token) => {
    session = window.OT.initSession(apiKey, sessionId);
    console.log('connectionUserMap', connectionUserMap.current)
    session.on("signal:broadcast-state-response", (event) => {
      try {
        const data = JSON.parse(event.data);

        console.log("Received broadcast state from active participant:", data);

        if (data.broadcastId) {
          sessionStorage.setItem("broadcastId", data.broadcastId);
          setBroadcastId(data.broadcastId);
          setIsBroadcasting(true);
        }

        if (data.streamsInLive && data.streamsInLive.length > 0) {
          sessionStorage.setItem(
            "streamsInLive",
            JSON.stringify(data.streamsInLive),
          );
        }

        if (data.isScreenshareInLive !== undefined) {
          sessionStorage.setItem(
            "isScreenshareInLive",
            data.isScreenshareInLive.toString(),
          );
        }

        if (data.layoutSelected) {
          sessionStorage.setItem("layoutSelected", data.layoutSelected);
          setSelectedLayout(data.layoutSelected);
        }

        setTimeout(() => {
          restoreBroadcastUI(subscriberArrayRef, resetLeftPanelStyles, changeLayout, toast);
        }, 2000);
      } catch (error) {
        console.error("Error handling broadcast state response:", error);
      }
    });
    session.on('connectionDestroyed', (event) => {
      try {
        if (!isCoHost()) return;

        const hostUserId = sessionStorage.getItem('hostUserId');

        if (!hostUserId) {
          console.warn('No hostUserId in session storage');
          return;
        }

        let disconnectedUserId = null;

        //Try to get from stored connection map
        if (connectionUserMap.current.has(event.connection.connectionId)) {
          disconnectedUserId = connectionUserMap.current.get(event.connection.connectionId);
          console.log('Got userId from connection map:', disconnectedUserId);
          connectionUserMap.current.delete(event.connection.connectionId);
        }

        if (!disconnectedUserId && event.connection.data) {
          try {
            const disconnectedUser = JSON.parse(event.connection.data);
            disconnectedUserId = disconnectedUser.userId;
            console.log('Got userId from connection.data:', disconnectedUserId);
          } catch (parseError) {
            console.warn('Failed to parse connection data:', parseError);
          }
        }

        if (!disconnectedUserId) {
          console.log('Attempting to identify disconnected user by elimination...');
          const remainingConnections = window.session?.connections || [];
          const remainingUserIds = new Set();

          remainingConnections.forEach(conn => {
            if (conn.data) {
              try {
                const data = JSON.parse(conn.data);
                if (data.userId) {
                  remainingUserIds.add(data.userId);
                }
              } catch (e) {
                console.log(e)
              }
            }
          });

          if (!remainingUserIds.has(hostUserId)) {
            disconnectedUserId = hostUserId;
            console.log('Identified host disconnection by elimination');
          }
        }

        console.log('Disconnected user ID:', disconnectedUserId, 'Host user ID:', hostUserId);

        if (disconnectedUserId === hostUserId) {
          console.log('Host disconnected - Co-host taking control');
          const userData = JSON.parse(sessionStorage.getItem('userData'));
          setActiveController(userData.userId);
          sessionStorage.setItem('activeController', userData.userId);
          toast.success('Host disconnected. You now have control');
        }
      } catch (err) {
        console.error('Error handling connectionDestroyed:', err);
      }
    });

    session.on('connectionCreated', (event) => {
      try {
        if (event.connection.data) {
          try {
            const userData = JSON.parse(event.connection.data);
            if (userData.userId) {
              connectionUserMap.current.set(event.connection.connectionId, userData.userId);
              console.log('Stored connection mapping:', event.connection.connectionId, '→', userData.userId);
            }
          } catch (parseError) {
            console.warn('Failed to parse connection data in connectionCreated:', parseError);
          }
        }
        setTimeout(() => {
          let joinedUserId = null;

          try {
            if (event.connection.data) {
              const joinedUser = JSON.parse(event.connection.data);
              joinedUserId = joinedUser.userId;
            }
          } catch (parseError) {
            console.warn('Failed to parse connection data:', parseError);
          }

          const hostUserId = sessionStorage.getItem('hostUserId');
          const currentController = sessionStorage.getItem('activeController');
          const userData = JSON.parse(sessionStorage.getItem('userData'));

          console.log('Connection created - User:', joinedUserId, 'Host:', hostUserId, 'Current controller:', currentController);

          // If host rejoins and co-host currently has control
          if (joinedUserId === hostUserId && currentController !== hostUserId) {
            console.log('Host rejoined - taking back control from co-host');

            // If current user is the co-host who has control
            if (isCoHost() && currentController === userData.userId) {
              setActiveController(hostUserId);
              sessionStorage.setItem('activeController', hostUserId);
              setHasPendingRequest(false);

              toast('Host has rejoined and taken back control');
            }

            // If current user is the host rejoining
            if (isPrimaryHost() && userData.userId === hostUserId) {
              setActiveController(hostUserId);
              sessionStorage.setItem('activeController', hostUserId);

              // Notify all users that host has taken back control
              if (window.session) {
                window.session.signal({
                  type: 'control-revoked',
                  data: JSON.stringify({
                    revokedBy: hostUserId,
                    reason: 'host_rejoined',
                    timestamp: Date.now(),
                  }),
                });
              }

              toast.success('Control automatically restored');
            }
          }
        }, 1000);
      } catch (err) {
        console.error('Error handling connectionCreated:', err);
      }
    });
    session.on("signal:broadcast-started", (event) => {
      try {
        const data = JSON.parse(event.data);
        const receivedBroadcastId = data.broadcastId;
        if (receivedBroadcastId) {
          sessionStorage.setItem("broadcastId", receivedBroadcastId);
        }
      } catch (error) {
        console.error(" Error handling broadcast-started signal:", error);
      }
    });

    session.on("signal:screenshare-ended", (event) => {
      let payload;
      try {
        payload =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      } catch (err) {
        console.warn("Bad screenshare-ended data:", event.data);
        payload = { streamId: null };
      }
      const endedStreamId = payload?.streamId;
      setIsScreenSharing(false);
      console.log(
        "Screenshare end signal received — cleaning UI (remote)",
        payload
      );

      const screenshareDiv = document.getElementById("hls-screen-shares");
      const mainPanel = document.getElementById("main-panel");
      const backstageButtonDiv = document.getElementById("backstage-button");

      // If the screenshare div is in main-panel, move it back to left panel/backstage.
      if (screenshareDiv) {
        if (mainPanel && mainPanel.contains(screenshareDiv)) {
          if (backstageButtonDiv) {
            backstageButtonDiv.insertAdjacentElement(
              "afterend",
              screenshareDiv
            );
          } else {
            const left = document.querySelector(".left-panel");
            if (left) left.appendChild(screenshareDiv);
          }
        }

        // Reset visual state
        screenshareDiv.style.display = "none";
        screenshareDiv.style.height = "25%";
        screenshareDiv.style.width = "100%";
        screenshareDiv.classList.remove("highlight-border");
      }

      if (endedStreamId) {
        subscriberArrayRef.current = subscriberArrayRef.current.filter(
          (s) => s.streamId !== endedStreamId
        );

        let storedStreams = JSON.parse(
          sessionStorage.getItem("streams") || "[]"
        );
        storedStreams = storedStreams.filter(
          (s) => s.streamId !== endedStreamId
        );
        sessionStorage.setItem("streams", JSON.stringify(storedStreams));

        let live = JSON.parse(sessionStorage.getItem("streamsInLive") || "[]");
        live = live.filter((s) => s.streamId !== endedStreamId);
        sessionStorage.setItem("streamsInLive", JSON.stringify(live));
      } else {
        let live = JSON.parse(sessionStorage.getItem("streamsInLive") || "[]");
        live = live.filter((s) => !s.streamId === null);
        sessionStorage.setItem("streamsInLive", JSON.stringify(live));
      }

      // Clear flag & recalc
      sessionStorage.setItem("isScreenshareInLive", "false");
      changeLayout(sessionStorage.getItem("layoutSelected"));

      setTimeout(() => {
        try {
          syncBroadcastState();
        } catch (e) {
          console.warn(e);
        }
      }, 500);
    });

    session.on("signal", (event) => {
      if (event.type === "signal:stream-pushed") {
        let streamId = sessionStorage.getItem("streams");
        let streamIds = JSON.parse(streamId) || [];

        let streamsInLive =
          JSON.parse(sessionStorage.getItem("streamsInLive")) || [];

        let signalStreamId;
        try {
          signalStreamId = JSON.parse(event.data);
        } catch (e) {
          console.error("Failed to parse signal data:", e);
          return;
        }

        const streamExists = subscriberArrayRef.current.some(
          (sub) => sub.streamId === signalStreamId.streamId
        );

        const isScreenshare = subscriberArrayRef.current.some(
          (sub) =>
            sub.stream &&
            sub.stream.videoType === "screen" &&
            sub.streamId === signalStreamId.streamId
        );

        if (!streamExists && !isScreenshare) {
          console.warn(
            "Received signal for non-existent stream:",
            signalStreamId.streamId
          );
          return;
        }

        const existingStreamIndex = streamsInLive.findIndex(
          (item) => item.streamId === signalStreamId.streamId
        );

        if (signalStreamId.action === "addStream") {
          if (existingStreamIndex === -1) {
            streamsInLive.push({
              streamId: signalStreamId.streamId,
              inLive: true,
            });
          } else {
            streamsInLive[existingStreamIndex].inLive = true;
          }
          changeLayout(sessionStorage.getItem("layoutSelected"));
        } else if (signalStreamId.action === "removeStream") {
          if (existingStreamIndex !== -1) {
            streamsInLive[existingStreamIndex].inLive = false;
          }
          changeLayout(sessionStorage.getItem("layoutSelected"));
        }

        sessionStorage.setItem("streamsInLive", JSON.stringify(streamsInLive));

        if (isScreenshare) {
          const screenshareDiv = document.getElementById("hls-screen-shares");
          const mainPanel = document.getElementById("main-panel");

          if (!screenshareDiv || !mainPanel) {
            console.error("Screenshare div or main panel not found");
            return;
          }
          if (signalStreamId.action === "addStream") {
            requestAnimationFrame(() => {
              if (!mainPanel.contains(screenshareDiv)) {
                mainPanel.appendChild(screenshareDiv);
                screenshareDiv.classList.add("highlight-border");

                const mainPanelDivCheck = checkDivsInMainPanel();
                if (mainPanelDivCheck.otDivCount === 0) {
                  screenshareDiv.style.height = "90%";
                  screenshareDiv.style.width = "100%";
                }

                sessionStorage.setItem("isScreenshareInLive", "true");
              }
            });

            setTimeout(() => {
              changeLayout(sessionStorage.getItem("layoutSelected"));
            }, 1000);
          } else if (signalStreamId.action === "removeStream") {
            if (mainPanel.contains(screenshareDiv)) {
              resetLayouts();
              screenshareDiv.style.height = "25%";
              screenshareDiv.style.width = "100%";
              screenshareDiv.style.position = "";
              screenshareDiv.style.top = "";
              screenshareDiv.style.right = "";
              screenshareDiv.style.zIndex = "";
              screenshareDiv.style.marginTop = "20px";
              screenshareDiv.classList.remove("highlight-border");

              const publishersDiv = document.getElementById("publishers");
              const subscribersDiv = document.getElementById("subscribers");

              if (publishersDiv && subscribersDiv) {
                publishersDiv.insertAdjacentElement(
                  "afterend",
                  screenshareDiv
                );
                console.log(
                  "Screenshare placed correctly between publishers and subscribers"
                );
              } else {
                const backstageButtonDiv =
                  document.getElementById("backstage-button");
                if (backstageButtonDiv) {
                  backstageButtonDiv.insertAdjacentElement(
                    "afterend",
                    screenshareDiv
                  );
                  console.log("Screenshare placed after backstage button");
                } else {
                  const leftPanel = document.querySelector(".left-panel");
                  if (leftPanel) {
                    leftPanel.appendChild(screenshareDiv);
                    console.log(
                      "Screenshare appended to left panel (fallback)"
                    );
                  }
                }
              }

              sessionStorage.setItem("isScreenshareInLive", "false");
              resetLeftPanelStyles();
            }

            setTimeout(() => {
              changeLayout(sessionStorage.getItem("layoutSelected"));
            }, 1000);
          }
          return;
        }

        const divId = streamIds.filter(
          (item) => item.streamId === signalStreamId.streamId
        );

        if (divId.length > 0) {
          const waitForElement = (id, retries = 5) =>
            new Promise((resolve) => {
              const check = () => {
                const el = document.getElementById(id);
                if (el) return resolve(el);
                if (retries === 0) return resolve(null);
                setTimeout(() => check(--retries), 500);
              };
              check();
            });

          waitForElement(divId[0].id).then((clickedDynamicDiv) => {
            if (!clickedDynamicDiv) {
              console.error("Could not find div for stream:", divId[0].id);
              return;
            }

            if (signalStreamId.action === "addStream") {
              requestAnimationFrame(() => {
                const mainPanel = document.querySelector(".main-panel");
                if (mainPanel && !mainPanel.contains(clickedDynamicDiv)) {
                  mainPanel.appendChild(clickedDynamicDiv);
                  clickedDynamicDiv.classList.add("highlight-border");

                  let myOriginalContainer;
                  if (
                    window.publisher &&
                    clickedDynamicDiv.id === window.publisher.id
                  ) {
                    myOriginalContainer = "publishers";
                  } else {
                    myOriginalContainer = "subscribers";
                  }

                  clickedDynamicDiv.setAttribute(
                    "data-original-container",
                    myOriginalContainer
                  );
                }
              });
              setTimeout(() => {
                changeLayout(sessionStorage.getItem("layoutSelected"));
              }, 1000);
            } else if (signalStreamId.action === "removeStream") {
              let mainPanelDivCheck = checkDivsInMainPanel();
              if (mainPanelDivCheck) {
                if (
                  mainPanelDivCheck.isHlsScreenSharePresent &&
                  mainPanelDivCheck.otDivCount === 0
                ) {
                  const screenShareDiv =
                    document.getElementById("hls-screen-shares");
                  if (screenShareDiv) {
                    screenShareDiv.style.height = "100%";
                    screenShareDiv.style.width = "100%";
                  }
                }
              }

              const mainPanel = document.getElementById("main-panel");
              if (mainPanel && mainPanel.contains(clickedDynamicDiv)) {
                let myTargetContainer;
                if (
                  window.publisher &&
                  clickedDynamicDiv.id === window.publisher.id
                ) {
                  myTargetContainer = "publishers";
                } else {
                  myTargetContainer = "subscribers";
                }

                const targetContainer =
                  document.getElementById(myTargetContainer);

                if (targetContainer) {
                  targetContainer.appendChild(clickedDynamicDiv);
                  clickedDynamicDiv.classList.remove("highlight-border");
                } else {
                  const leftPanel = document.querySelector(".left-panel");
                  if (leftPanel) {
                    if (myTargetContainer === "publishers") {
                      const publishersDiv =
                        document.getElementById("publishers");
                      if (publishersDiv) {
                        publishersDiv.appendChild(clickedDynamicDiv);
                      } else {
                        leftPanel.appendChild(clickedDynamicDiv);
                      }
                    } else {
                      const subscribersDiv =
                        document.getElementById("subscribers");
                      if (subscribersDiv) {
                        subscribersDiv.appendChild(clickedDynamicDiv);
                      } else {
                        leftPanel.appendChild(clickedDynamicDiv);
                      }
                    }
                    clickedDynamicDiv.classList.remove("highlight-border");
                  }
                }

                clickedDynamicDiv.setAttribute(
                  "data-original-container",
                  myTargetContainer
                );
              }
            }
            setTimeout(() => {
              changeLayout(sessionStorage.getItem("layoutSelected"));
            }, 2000);
            resetLeftPanelStyles();

          });
        }
      }
    });

    window.session = session;

    if (!window.publisher) {
      const savedVideoDeviceId = localStorage.getItem('selectedVideoDevice');
      const filterPayload = localStorage.getItem('filterPayload');

      const publisherOptions = {
        publishAudio: state.waitingRoomReducer.localAudio,
        publishVideo: state.waitingRoomReducer.localVideo,
        fitMode: 'contain',
        insertMode: 'append',
        width: '100%',
        height: '100%',
        resolution: '1280x720',
        audioFallback: { publisher: true },
      };

      if (savedVideoDeviceId) {
        publisherOptions.videoSource = savedVideoDeviceId;
      }

      if (filterPayload) {
        publisherOptions.videoFilter = {
          type: filterPayload === 'high' || filterPayload === 'low'
            ? 'backgroundBlur'
            : 'backgroundReplacement',
          backgroundImgUrl: filterPayload,
        };
      }

      const publisher = window.OT.initPublisher('publishers', publisherOptions, handleCallback);
      setPublisher(publisher);
      window.publisher = publisher;
      subscriberArrayRef.current.push(window.publisher);
      setTimeout(() => {
        if (window.publisher && window.publisher.id) {
          addRoleLabelToVideo(window.publisher.id, window.publisher, connectionUserMap);
        }
      }, 1000);
    }

    session.connect(token, (error) => {
      if (error) {
        handleCallback(error);
      } else {
        if (window.publisher) {
          session.publish(window.publisher, handleCallback);
        }
        setIsLocalUserConnected(true);
        setIsDisconnected(false);
      }
    });

    session.on('streamCreated', (event) => {
      setCurrentHost((x) => x + 1);
      if (event.stream.videoType === 'screen') {
        if (sessionStorage.getItem('layoutSelected') === 'custom' && sessionId) {
          getStreamData(sessionId);
        }
        setIsScreenSharing(true);
        const screenshareDiv = document.getElementById('hls-screen-shares');
        if (screenshareDiv) {
          screenshareDiv.style.display = 'block';
          const mainPanel = document.getElementById('main-panel');
          const backstageButtonDiv =
            document.getElementById('backstage-button');
          if (
            mainPanel &&
            mainPanel.contains(screenshareDiv) &&
            sessionStorage.getItem('isScreenshareInLive') !== 'true'
          ) {

            if (backstageButtonDiv)
              backstageButtonDiv.insertAdjacentElement(
                'afterend',
                screenshareDiv
              );
          }
        }
      }

      const streamContainer =
        event.stream.videoType === 'screen'
          ? 'hls-screen-shares'
          : 'subscribers';
      window.subscriber = session.subscribe(
        event.stream,
        streamContainer,
        {
          insertMode: 'append',
          width: '100%',
          height: '100%',
        },
        handleCallback
      );

      setTimeout(() => {
        const subscriberDiv = document.getElementById(window.subscriber.id);
        if (subscriberDiv) {
          subscriberDiv.setAttribute(
            'data-original-container',
            streamContainer
          );
        }
      }, 100);

      subscriberArrayRef.current.push(window.subscriber);
      setCount(subscriberArrayRef.current.length);
      setStreams(subscriberArrayRef.current);

      let data = subscriberArrayRef.current.map((item) => {
        return { streamId: item.streamId, id: item.id };
      });
      sessionStorage.setItem('streams', JSON.stringify(data));
      setCondition(true);
      setTimeout(() => {
        if (window.subscriber && window.subscriber.id) {
          addRoleLabelToVideo(window.subscriber.id, window.subscriber, connectionUserMap);
        }
      }, 800);
    });

    session.on('streamDestroyed', (event) => {
      if (event.stream.videoType === 'screen') {
        console.log('Screenshare stream destroyed — cleaning UI + state');
        setIsScreenSharing(false);

        try {
          if (session) {
            session.signal({
              type: 'screenshare-ended',
              data: JSON.stringify({
                streamId: event.stream.streamId,
                timestamp: Date.now(),
                originalContainer:
                  document
                    .getElementById('hls-screen-shares')
                    ?.getAttribute('data-original-container') || 'left-panel',
              }),
            });
          }
        } catch (err) {
          console.warn('screenshare-end signal failed:', err);
        }

        const screenshareDiv = document.getElementById('hls-screen-shares');
        if (screenshareDiv) {
          const backstageButtonDiv =
            document.getElementById('backstage-button');
          if (
            backstageButtonDiv &&
            document.getElementById('main-panel')?.contains(screenshareDiv)
          ) {
            backstageButtonDiv.insertAdjacentElement(
              'afterend',
              screenshareDiv
            );
          }

          screenshareDiv.style.display = 'none';
          screenshareDiv.style.height = '25%';
          screenshareDiv.style.width = '100%';
          screenshareDiv.classList.remove('highlight-border');
        }

        subscriberArrayRef.current = subscriberArrayRef.current.filter(
          (s) => s.streamId !== event.stream.streamId
        );

        let storedStreams = JSON.parse(
          sessionStorage.getItem('streams') || '[]'
        );
        storedStreams = storedStreams.filter(
          (s) => s.streamId !== event.stream.streamId
        );
        sessionStorage.setItem('streams', JSON.stringify(storedStreams));

        let live = JSON.parse(sessionStorage.getItem('streamsInLive') || '[]');
        live = live.filter((s) => s.streamId !== event.stream.streamId);
        sessionStorage.setItem('streamsInLive', JSON.stringify(live));

        sessionStorage.setItem('isScreenshareInLive', 'false');
        changeLayout(sessionStorage.getItem('layoutSelected'));

        setTimeout(() => {
          try {
            syncBroadcastState();
          } catch (e) {
            console.warn(e);
          }
        }, 600);

        return;
      }

      console.log('Camera stream destroyed:', event.stream.streamId);

      // Remove from subscriber array
      subscriberArrayRef.current = subscriberArrayRef.current.filter(
        (sub) => sub.streamId !== event.stream.streamId
      );
      setStreams(subscriberArrayRef.current);
      setCount(subscriberArrayRef.current.length);

      // Update sessionStorage
      let streams = JSON.parse(sessionStorage.getItem('streams')) || [];
      streams = streams.filter(
        (item) => item.streamId !== event.stream.streamId
      );
      sessionStorage.setItem('streams', JSON.stringify(streams));

      let streamsInLive =
        JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
      streamsInLive = streamsInLive.filter(
        (item) => item.streamId !== event.stream.streamId
      );
      sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));

      // Remove from operations in progress
      operationsInProgress.current.delete(event.stream.streamId);

      // Remove the stream from the UI
      const streamDiv = document.getElementById(event.stream.id);
      if (streamDiv) {
        console.log('Removing stream div from DOM:', event.stream.id);
        streamDiv.remove();
      }

      setCurrentHost((x) => x - 1);
      setCondition(false);
      changeLayout(sessionStorage.getItem('layoutSelected'));

      // Sync after removal
      setTimeout(() => syncBroadcastState(), 500);
    });
  };

  function handleCallback(error) {
    if (error) {
      console.log('error: ' + error.message);
    } else {
      console.log('callback success');
    }
  }
  useEffect(() => {
    const updateAllLabels = () => {
      const hostUserId = sessionStorage.getItem('hostUserId');
      const cohostUserId = sessionStorage.getItem('cohostUserId');

      if (!hostUserId && !cohostUserId) return;

      subscriberArrayRef.current.forEach((subscriber) => {
        if (subscriber && subscriber.id) {
          const videoElement = document.getElementById(subscriber.id);
          if (videoElement && !videoElement.querySelector('.role-label')) {
            addRoleLabelToVideo(subscriber.id, subscriber, connectionUserMap);
          }
        }
      });
    };

    if (subscriberArrayRef.current.length > 0) {
      updateAllLabels();
    }

    const labelInterval = setInterval(updateAllLabels, 10000);

    return () => clearInterval(labelInterval);
  }, [streams, subscriberArrayRef.current.length]);

  useEffect(() => {
    setTimeout(() => {
      syncBroadcastState().then(() => pushStreamsToLiveSection());
    }, 9000);
  }, []);

  useEffect(() => {
    const currentLayout = sessionStorage.getItem('layoutSelected');
    if (!currentLayout) {
      setSelectedLayout('bestFit');
      sessionStorage.setItem('layoutSelected', 'bestFit');
      const mainPanel = document.getElementById('main-panel');
      if (mainPanel) mainPanel.classList.add('layout-bestfit');
    } else {
      setSelectedLayout(currentLayout);
      const mainPanel = document.getElementById('main-panel');
      if (mainPanel) {
        if (currentLayout === 'bestFit') {
          mainPanel.classList.add('layout-bestfit');
        } else {
          mainPanel.classList.remove('layout-bestfit');
        }
      }
    }
  }, []);
  const handleStartBroadcast = async (liveEventUrl, isRetry = false) => {
    setLiveEventUrl(liveEventUrl);
    const streamMode = sessionStorage.getItem('broadcastType');

    try {
      // Set loading state
      setIsBroadcastStarting(true);

      if (isRetry) {
        setBroadcastError(null);
        setIsRetrying(true);
        console.log(
          `Retrying broadcast start (attempt ${retryCount + 1}/3)...`
        );
      } else {
        setRetryCount(0);
        console.log('Starting broadcast...');
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/start`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            session_id: session.sessionId,
            liveEventUrl,
            streamMode: streamMode || 'manual',
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        let res;
        try {
          res = JSON.parse(errorText);
        } catch {
          res = { message: errorText };
        }

        // Handle specific error types
        let errorMessage = 'Failed to start broadcast';
        let errorDetails = '';

        if (response.status === 409) {
          errorMessage = 'Broadcast already in progress';
          errorDetails = 'Another broadcast session is currently active';
        } else if (response.status === 503) {
          errorMessage = 'Media channel unavailable';
          errorDetails =
            'The media channel is currently stopping or in error state';
        } else if (response.status === 400) {
          errorMessage = 'Invalid broadcast configuration';
          errorDetails = res.message || 'Please check your broadcast settings';
        } else if (response.status === 500) {
          errorMessage = 'Server error';

          errorDetails =
            res.message ||
            'Internal server error occurred while starting broadcast';
        } else if (response.status >= 500) {
          errorMessage = 'Service unavailable';
          errorDetails = 'The broadcast service is currently unavailable';
        } else if (!navigator.onLine) {
          errorMessage = 'Network connection lost';
          errorDetails = 'Please check your internet connection and try again';
        } else {
          errorMessage = `HTTP ${response.status} Error`;
          errorDetails =
            res.message || response.statusText || 'Unknown server error';
        }

        throw new Error(errorDetails);
      }

      const res = await response.json();

      if (!res.broadcast || !res.broadcast.id) {
        throw new Error('Invalid broadcast response: Missing broadcast ID');
      }

      setButtonState('start');
      sessionStorage.setItem('broadcastId', res.broadcast.id);
      setBroadcastId(res.broadcast.id);
      const currentLayout = sessionStorage.getItem('layoutSelected');
      if (!currentLayout) {
        setSelectedLayout('bestFit');
        sessionStorage.setItem('layoutSelected', 'bestFit');
        changeLayout('bestFit');
      }
      session.signal(
        {
          type: 'broadcast-started',
          data: JSON.stringify({
            broadcastId: res.broadcast.id,
          }),

        },
        (error) => {
          if (error) {
            console.error('Error sending broadcast ID:', error);
          } else {
            console.log('Successfully sent broadcast ID to co-host');
          }
        }
      );
      broadcast = res.broadcast.id;
      setIsBroadcasting(true);
      setIsRetrying(false);
      setRetryCount(0);
      setIsBroadcastStarting(false);

      // Notify parent window of success
      window.parent.postMessage({ type: 'BROADCAST_SUCCESS', data: res }, '*');

      console.log('Broadcast started successfully:', res);
    } catch (error) {
      console.error('Broadcast start failed:', error);
      await fetchMediaChannelStatus();
      // Stop loading states
      setIsBroadcastStarting(false);
      setIsRetrying(false);
      setIsBroadcasting(false);

      // Clear any broadcast data
      sessionStorage.removeItem('broadcastId');
      setBroadcastId('');

      const errorData = {
        type: 'START_BROADCAST_ERROR',
        message: 'Server error: Broadcast failed',
        details: error.message || 'Unknown error starting broadcast',
        mediaChannelStatus: mediaChannelStatus || 'Unknown',
        timestamp: new Date().toISOString(),
        canRetry: true,
        isNetworkError: !navigator.onLine || error.message.includes('fetch'),
        httpStatus: error.status || 'Unknown',
      };

      setBroadcastError(errorData);
      setShowErrorModal(true);

      // Notify parent window of error to stop loading
      window.parent.postMessage(
        {
          type: 'BROADCAST_ERROR',
          error: errorData,
          action: 'stop_loading',
        },
        '*'
      );
    }
  };

  const handleStreamOperation = async (streamId, action, retryCount = 3) => {
    const broadcastId = sessionStorage.getItem('broadcastId');

    if (!broadcastId) {
      toast.error('No active broadcast found');
      return false;
    }

    try {
      // Check broadcast health before operation
      const isHealthy = await checkBroadcastStatus(broadcastId);
      if (!isHealthy) {
        return false;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/${action}/${broadcastId}/${streamId}`,
        { method: 'POST' }
      );

      const result = await response.json();

      if (!response.ok) {
        let errorMessage = `Failed to ${action} stream`;
        let errorDetails = result.message || '';

        if (response.status === 404) {
          errorMessage = 'Stream not found';
          errorDetails = 'The stream may have been disconnected';
        } else if (response.status === 409) {
          errorMessage = 'Stream operation conflict';
          errorDetails = 'Stream is already being processed';
        }

        throw new Error(`${errorMessage}: ${errorDetails}`);
      }

      return true;
    } catch (error) {
      console.error(`Stream ${action} failed:`, error);

      if (retryCount > 0) {
        toast(`Retrying stream ${action}... (${3 - retryCount + 1}/3)`);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        return handleStreamOperation(streamId, action, retryCount - 1);
      }

      setBroadcastError({
        type: 'STREAM_OPERATION_ERROR',
        message: `Failed to ${action} stream`,
        details: error.message,
        mediaChannelStatus: mediaChannelStatus,
        timestamp: new Date().toISOString(),
        canRetry: true,
      });
      setShowErrorModal(true);

      return false;
    }
  };

  // Retry functionality
  const handleRetry = async () => {
    if (!broadcastError || retryCount >= 3) {
      toast.error('Maximum retry attempts reached');
      return;
    }

    setRetryCount((prev) => prev + 1);
    setShowErrorModal(false);

    switch (broadcastError.type) {
      case 'START_BROADCAST_ERROR':
        await handleStartBroadcast(liveEventUrl, true);
        break;
      case 'BROADCAST_STATUS_ERROR':
        await checkBroadcastStatus(sessionStorage.getItem('broadcastId'));
        break;
      default:
        toast('Retrying operation...');
    }
  };

  // Error Modal Component
  const ErrorModal = () => {
    if (!showErrorModal || !broadcastError) return null;

    return (
      <div
        className='error-modal-overlay'
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10000,
        }}
        onClick={(e) =>
          e.target === e.currentTarget && setShowErrorModal(false)
        }
      >
        <div
          className='error-modal'
          style={{
            backgroundColor: '#1a1a1a',
            border: '1px solid #ff4444',
            padding: '24px',
            borderRadius: '8px',
            maxWidth: '500px',
            width: '90%',
            maxHeight: '80vh',
            overflow: 'auto',
            color: 'white',
            boxShadow: '0 8px 32px rgba(255,68,68,0.3)',
          }}
        >
          <div className='error-header' style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div
                style={{
                  width: '24px',
                  height: '24px',
                  backgroundColor: '#ff4444',
                  borderRadius: '50%',
                  marginRight: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  fontWeight: 'bold',
                }}
              >
                !
              </div>
              <h3 style={{ margin: 0, color: '#ff4444', fontSize: '18px' }}>
                Broadcast Failed
              </h3>
            </div>
          </div>

          <div className='error-content' style={{ marginBottom: '20px' }}>
            <div style={{ marginBottom: '12px' }}>
              <strong style={{ color: '#ff6b6b' }}>Error:</strong>
              <p style={{ margin: '4px 0', color: '#e0e0e0' }}>
                {broadcastError.message}
              </p>
            </div>

            {broadcastError.details && (
              <div style={{ marginBottom: '12px' }}>
                <strong style={{ color: '#ff6b6b' }}>Details:</strong>
                <p
                  style={{
                    margin: '4px 0',
                    color: '#b0b0b0',
                    fontSize: '14px',
                  }}
                >
                  {broadcastError.details}
                </p>
              </div>
            )}

            <div style={{ marginBottom: '12px' }}>
              <strong style={{ color: '#ff6b6b' }}>
                Media Channel Status:
              </strong>
              <span
                style={{
                  marginLeft: '8px',
                  padding: '2px 8px',
                  backgroundColor: '#333',
                  borderRadius: '4px',
                  fontSize: '12px',
                  color:
                    broadcastError.mediaChannelStatus === 'ERROR'
                      ? '#ff4444'
                      : '#4CAF50',
                }}
              >
                {mediaChannelStatus}
              </span>
            </div>

            <div
              style={{ marginBottom: '12px', fontSize: '12px', color: '#888' }}
            >
              <strong>Time:</strong>{' '}
              {new Date(broadcastError.timestamp).toLocaleString()}
            </div>

            {retryCount > 0 && (
              <div style={{ fontSize: '12px', color: '#ffa726' }}>
                <strong>Retry Attempts:</strong> {retryCount}/3
              </div>
            )}

            {broadcastError.isNetworkError && (
              <div
                style={{
                  marginTop: '12px',
                  padding: '8px',
                  backgroundColor: '#2d3748',
                  borderLeft: '4px solid #ffa726',
                  borderRadius: '4px',
                }}
              >
                <p style={{ margin: 0, fontSize: '12px', color: '#ffa726' }}>
                  Network Error: Check your internet connection and VPN settings
                </p>
              </div>
            )}
          </div>

          <div
            className='error-actions'
            style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end',
            }}
          >
            <button
              onClick={() => setShowErrorModal(false)}
              style={{
                padding: '10px 16px',
                border: '1px solid #666',
                borderRadius: '4px',
                backgroundColor: 'transparent',
                color: 'white',
                cursor: 'pointer',
                fontSize: '14px',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#333')}
              onMouseOut={(e) =>
                (e.target.style.backgroundColor = 'transparent')
              }
            >
              Close
            </button>

            {broadcastError.canRetry && retryCount < 3 && (
              <button
                onClick={handleRetry}
                disabled={isRetrying || isBroadcastStarting}
                style={{
                  padding: '10px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: isRetrying ? '#666' : '#ff6b6b',
                  color: 'white',
                  cursor:
                    isRetrying || isBroadcastStarting
                      ? 'not-allowed'
                      : 'pointer',
                  fontSize: '14px',
                  opacity: isRetrying || isBroadcastStarting ? 0.6 : 1,
                }}
                onMouseOver={(e) =>
                  !isRetrying &&
                  !isBroadcastStarting &&
                  (e.target.style.backgroundColor = '#ff4444')
                }
                onMouseOut={(e) =>
                  !isRetrying &&
                  !isBroadcastStarting &&
                  (e.target.style.backgroundColor = '#ff6b6b')
                }
              >
                {isRetrying || isBroadcastStarting
                  ? 'Retrying...'
                  : `Try Again (${3 - retryCount} left)`}
              </button>
            )}

            {retryCount >= 3 && (
              <button
                onClick={() => window.location.reload()}
                style={{
                  padding: '10px 16px',
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: '#4CAF50',
                  color: 'white',
                  cursor: 'pointer',
                  fontSize: '14px',
                }}
              >
                Refresh Page
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    return () => {
      const intervalId = sessionStorage.getItem('statusCheckInterval');
      if (intervalId) {
        clearInterval(intervalId);
        sessionStorage.removeItem('statusCheckInterval');
      }
    };
  }, []);

  const handleStopBroadcast = () => {
    sessionStorage.removeItem('isScreenshareInLive');
    sessionStorage.removeItem('streamsInLive');
    sessionStorage.removeItem('streams');
    sessionStorage.removeItem('layoutSelected');
    sessionStorage.removeItem('broadcastType');
    sessionStorage.removeItem('streamMode');
    sessionStorage.removeItem('screenshareLayout');
    sessionStorage.removeItem('isScreenshareClicked');
    sessionStorage.removeItem('layouts');
    sessionStorage.removeItem('IsHost');
    sessionStorage.removeItem('hostPermission');
    sessionStorage.removeItem('activeController');
    localStorage.removeItem('selectedVideoDevice')
    fetch(
      `${process.env.REACT_APP_API_URL
      }/v2/livemeeting/broadcast/stop/${sessionStorage.getItem('broadcastId')}`,
      {
        method: 'POST',
      }
    )
      .then((res) => {
        sessionStorage.removeItem('broadcastId');
        setIsBroadcasting(false);
        return res.json();
      })
      .then((res) => {
        setButtonState('stop');
        sessionStorage.removeItem('streamMode');
        sessionStorage.removeItem('broadcastId');
      })
      .catch(handleCallback);
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      if (broadcastError?.isNetworkError) {
        toast.success('Connection restored. You can try again now.');
      }
    };

    const handleOffline = () => {
      if (isBroadcastStarting || isBroadcasting) {
        setBroadcastError({
          type: 'NETWORK_ERROR',
          message: 'Internet connection lost',
          details: 'Your broadcast may have been interrupted',
          mediaChannelStatus: mediaChannelStatus || 'Unknown',
          timestamp: new Date().toISOString(),
          canRetry: true,
          isNetworkError: true,
        });
        setShowErrorModal(true);
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [broadcastError, isBroadcastStarting, isBroadcasting, mediaChannelStatus]);

  const handleMessage = (e) => {
    try {
      const jsonParse = JSON.parse(e.data);

      if (jsonParse.action === 'startBroadcastClick') {
        setLiveEventUrl(jsonParse.liveEventUrl);
        handleStartBroadcast(jsonParse.liveEventUrl);
      }

      if (jsonParse.action === 'endBroadcastClick') {
        handleStopBroadcast();
      }

      if (jsonParse.action === 'retryBroadcast') {
        handleRetry();
      }
    } catch (error) {
      console.error('Error parsing message data:', error);
      setBroadcastError({
        type: 'MESSAGE_PARSE_ERROR',
        message: 'Failed to parse broadcast command',
        details: error.message,
        mediaChannelStatus: mediaChannelStatus || 'Unknown',
        timestamp: new Date().toISOString(),
        canRetry: false,
      });
      setShowErrorModal(true);
    }
  };

  const startScreenSharing = () => {
    setIsCurrentHost(true);
    const OT = window.OT;
    setIsScreenSharing(true);
    const screenshareDiv = document.getElementById('hls-screen-shares');
    if (screenshareDiv) {
      screenshareDiv.style.display = 'block';
    }
    let publishOptions = {
      videoSource: 'screen',
      width: '100%',
      height: '25%',
    };
    window.hlsScreenShare = OT.initPublisher(
      'hls-screen-shares',
      publishOptions,
      function (error) {
        if (error) {
          console.log(error);
        } else {
          window.session.publish(window.hlsScreenShare, function (error) {
            if (error) {
              console.log(error);
            } else {
              console.log('Screenshare published successfully');
              console.log('Screenshare streamId:', window.hlsScreenShare.stream.streamId);

              subscriberArrayRef.current.push(window.hlsScreenShare);
              setStreams(subscriberArrayRef.current);

              // Update stored streams
              let data = subscriberArrayRef.current.map((item) => {
                return { streamId: item.streamId, id: item.id };
              });
              sessionStorage.setItem('streams', JSON.stringify(data));
            }
          });
        }
      }
    );
  };

  const stopScreenSharing = () => {
    setIsCurrentHost(false);
    setIsScreenSharing(false);
    window.session.unpublish(window.hlsScreenShare);
    window.hlsScreenShare.destroy();

    if (window.hlsScreenShare) {
      const leftPanel = document.querySelector('.left-panel');
      const publishersDiv = document.getElementById('publishers');
      if (leftPanel && publishersDiv) {
        const newScreenShareDiv = document.createElement('div');
        newScreenShareDiv.id = 'hls-screen-shares';
        newScreenShareDiv.style.display = 'none';
        newScreenShareDiv.style.height = '25%';
        newScreenShareDiv.style.width = '100%';
        newScreenShareDiv.style.marginTop = '10px';
        newScreenShareDiv.className =
          sessionStorage.getItem('broadcastType') === 'manual'
            ? 'screen-share hls-screen-shares OT_root OT_publisher OT_fit-mode-contain'
            : 'screen-share hls-screen-shares OT_root OT_publisher OT_fit-mode-contain';

        newScreenShareDiv.addEventListener('click', handleScreenshareClicked);

        const mainPanel = document.getElementById('main-panel');
        const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
          (div) => div.id && div.id.startsWith('OT')
        );
        if (otDiv) {
          otDiv.style.height = '100%';
          otDiv.style.width = '100%';
        }

        publishersDiv.insertAdjacentElement('afterend', newScreenShareDiv);
        console.log('Screen share div reappended below the publishers div.');
      }
    }
  };


  const getStreamData = (sessionId) => {
    if (!sessionId || isFetchingStreamData.current) return;
    isFetchingStreamData.current = true;

    fetch(`${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/streamData/${sessionId}`, {
      method: 'POST'
    })
      .then(res => res.json())
      .then(res => {
        setStreamData(res);
        setStreamClass(res.response);
      })
      .catch(handleCallback)
      .finally(() => {
        isFetchingStreamData.current = false;
      });
  };

  const setStreamClass = (streamData) => {
    let streamDataArray = [];
    const streamDataSet =
      streamData &&
      streamData.map((item) => {
        if (item.videoType === 'screen') {
          let data = { id: item.id, layoutClassList: ['full'] };
          streamDataArray.push(data);
        }
      });
    fetch(
      `${process.env.REACT_APP_API_URL}/v2/livemeeting/broadcast/setStreamClassList`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId,
          classListArray: streamDataArray,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        console.log('Class are set:', res);
      })
      .catch(handleCallback);
  };

  function resetLeftPanelStyles() {
    const leftPanel = document.querySelector('.left-panel');
    if (leftPanel) {
      const publishersDiv = document.querySelector(
        '.left-panel #publishers div[id^="OT_"]'
      );

      if (publishersDiv) {
        publishersDiv.style.height = '100%';
        publishersDiv.style.width = '100%';
        publishersDiv.style.position = '';
      }

      const subscriberDivs = document.querySelectorAll(
        '.left-panel #subscribers div[id^="OT_"]'
      );

      subscriberDivs.forEach((div) => {
        div.style.height = '100%';
        div.style.width = '100%';
        div.style.position = '';
      });
    }
  }

  const handleScreenShareClick = async () => {
    changeLayout(sessionStorage.getItem('layoutSelected'));
    setIsScreenshareClicked(false);

    const mainPanel = document.getElementById('main-panel');
    const screenshareDiv = document.getElementById('hls-screen-shares');

    if (!screenshareDiv) {
      toast.error('Screenshare element not found');
      return;
    }

    const screenshareStream = subscriberArrayRef.current.find(
      (sub) => sub.stream && sub.stream.videoType === 'screen'
    );

    if (!screenshareStream || !screenshareStream.streamId) {
      toast.error('Screenshare stream not found');
      console.error('Screenshare stream not found in subscriberArrayRef');
      return;
    }

    const streamId = screenshareStream.streamId;

    // Check if already processing
    if (operationsInProgress.current.has(streamId)) {
      toast('Screenshare operation already in progress...');
      return;
    }

    if (isProcessingAnyClick.current) {
      toast('Please wait, processing previous stream...');
      return;
    }

    const otDivs = Array.from(mainPanel.querySelectorAll('div')).filter(
      (div) =>
        div.id && div.id.startsWith('OT') && !div.closest('#hls-screen-shares')
    );
    const isInMainPanel = mainPanel.contains(screenshareDiv);
    const currentVideoPresenters = otDivs.length;

    if (!isInMainPanel && currentVideoPresenters >= 6) {
      toast.error('Maximum 6 sources allowed on screen at once.');
      return;
    }

    isProcessingAnyClick.current = true;
    operationsInProgress.current.set(streamId, true);

    document.querySelectorAll('[id^="OT_"]').forEach((div) => {
      div.style.pointerEvents = 'none';
    });
    document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
      div.style.pointerEvents = 'none';
    });

    screenshareDiv.classList.toggle('highlight-border');
    let toastId = toast.loading('Processing...');

    const timeoutId = setTimeout(() => {
      toast.error('Screenshare operation timed out', { id: toastId });
      operationsInProgress.current.delete(streamId);
      isProcessingAnyClick.current = false;
      document.querySelectorAll('[id^="OT_"]').forEach((div) => {
        div.style.pointerEvents = 'auto';
      });
      document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
        div.style.pointerEvents = 'auto';
      });
      syncBroadcastState();
    }, 15000);

    try {
      // Verify screenshare still exists
      const stillExists = subscriberArrayRef.current.some(
        (sub) => sub.stream && sub.stream.videoType === 'screen' && sub.streamId === streamId
      );

      if (!stillExists) {
        toast.error('Screenshare stream no longer exists', { id: toastId });
        sessionStorage.setItem('isScreenshareInLive', 'false');
        syncBroadcastState();
        return;
      }

      const action = isInMainPanel ? 'removeStream' : 'addStream';

      // Verify current state BEFORE attempting operation
      const currentBroadcastStreams = await getBroadcastState(true);
      const isCurrentlyInBroadcast = currentBroadcastStreams.includes(streamId);

      // Handle "already removed" case
      if (action === 'removeStream' && !isCurrentlyInBroadcast) {
        console.warn('Screenshare already removed from broadcast - syncing UI');
        toast.dismiss(toastId);

        sessionStorage.setItem('isScreenshareInLive', 'false');

        // Update streamsInLive
        let streamsInLive =
          JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
        const streamIndex = streamsInLive.findIndex((item) => item.streamId === streamId);
        if (streamIndex !== -1) {
          streamsInLive[streamIndex].inLive = false;
          sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));
        }

        // Force UI update
        resetLayouts();
        screenshareDiv.style.height = '25%';
        screenshareDiv.style.width = '100%';
        const backstageButtonDiv = document.getElementById('backstage-button');
        if (backstageButtonDiv && mainPanel.contains(screenshareDiv)) {
          backstageButtonDiv.insertAdjacentElement('afterend', screenshareDiv);
        }
        screenshareDiv.classList.remove('highlight-border');
        // Send signal to other clients
        handleStreamPushed(streamId, 'removeStream', 'subscribers');

        resetLeftPanelStyles();
        changeLayout(sessionStorage.getItem('layoutSelected'));

        // Clear locks
        clearTimeout(timeoutId);
        operationsInProgress.current.delete(streamId);
        isProcessingAnyClick.current = false;
        document.querySelectorAll('[id^="OT_"]').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });
        document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });

        return;
      }

      // Handle "already added" case
      if (action === 'addStream' && isCurrentlyInBroadcast) {
        console.warn('Screenshare already in broadcast - syncing UI');
        toast.dismiss(toastId);

        sessionStorage.setItem('isScreenshareInLive', 'true');

        // Update streamsInLive
        let streamsInLive =
          JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
        const streamIndex = streamsInLive.findIndex((item) => item.streamId === streamId);
        if (streamIndex === -1) {
          streamsInLive.push({ streamId: streamId, inLive: true });
        } else {
          streamsInLive[streamIndex].inLive = true;
        }
        sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));

        if (!mainPanel.contains(screenshareDiv)) {
          mainPanel.appendChild(screenshareDiv);
          if (mainPanelDivCheck.otDivCount === 0) {
            screenshareDiv.style.height = '90%';
          }
          screenshareDiv.classList.add('highlight-border');
        }

        resetLeftPanelStyles();
        changeLayout(sessionStorage.getItem('layoutSelected'));

        // Clear locks
        clearTimeout(timeoutId);
        operationsInProgress.current.delete(streamId);
        isProcessingAnyClick.current = false;
        document.querySelectorAll('[id^="OT_"]').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });
        document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
          div.style.pointerEvents = 'auto';
        });

        return;
      }

      // Proceed with API call
      const response = await fetch(
        `${process.env.REACT_APP_API_URL
        }/v2/livemeeting/broadcast/${action}/${sessionStorage.getItem(
          'broadcastId'
        )}/${streamId}`,
        { method: 'POST' }
      );
      const result = await response.json();

      if (!response.ok) {
        if (
          result.message &&
          (result.message.includes('already removed') ||
            result.message.includes('not found'))
        ) {
          console.warn('API reports screenshare already removed - forcing sync');
          toast.dismiss(toastId);

          sessionStorage.setItem('isScreenshareInLive', 'false');

          // Update streamsInLive
          let streamsInLive =
            JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
          const streamIndex = streamsInLive.findIndex((item) => item.streamId === streamId);
          if (streamIndex !== -1) {
            streamsInLive[streamIndex].inLive = false;
            sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));
          }

          resetLayouts();
          screenshareDiv.style.height = '25%';
          screenshareDiv.style.width = '100%';
          const backstageButtonDiv = document.getElementById('backstage-button');
          if (backstageButtonDiv && mainPanel.contains(screenshareDiv)) {
            backstageButtonDiv.insertAdjacentElement('afterend', screenshareDiv);
          }
          screenshareDiv.classList.remove('highlight-border');
          handleStreamPushed(streamId, 'removeStream', 'subscribers');

          resetLeftPanelStyles();
          changeLayout(sessionStorage.getItem('layoutSelected'));

          await getBroadcastState(true);

          return;
        }

        throw new Error(result.message || 'API call failed');
      }

      // Verify operation succeeded
      await new Promise((resolve) => setTimeout(resolve, 800));
      const verifiedStreams = await getBroadcastState(true);
      const operationSucceeded =
        action === 'addStream'
          ? verifiedStreams.includes(streamId)
          : !verifiedStreams.includes(streamId);

      if (!operationSucceeded) {
        throw new Error(
          'Screenshare operation failed to update broadcast state'
        );
      }

      toast.success(
        `Source ${action === 'addStream' ? 'Added.' : 'Removed.'}`,
        { id: toastId }
      );

      // Update cache
      broadcastStateCache.current = {
        streams: verifiedStreams,
        lastUpdate: Date.now(),
        cacheTimeout: 2000,
      };

      // Update streamsInLive
      let streamsInLive =
        JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
      const streamIndex = streamsInLive.findIndex((item) => item.streamId === streamId);

      if (action === 'addStream') {
        if (streamIndex === -1) {
          streamsInLive.push({ streamId: streamId, inLive: true });
        } else {
          streamsInLive[streamIndex].inLive = true;
        }
      } else {
        if (streamIndex !== -1) {
          streamsInLive[streamIndex].inLive = false;
        }
      }
      sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));

      // Update UI
      if (!isInMainPanel) {
        mainPanel.appendChild(screenshareDiv);
        if (mainPanelDivCheck.otDivCount === 0) {
          screenshareDiv.style.height = '90%';
        }
      } else {
        resetLayouts();
        screenshareDiv.style.height = '25%';
        screenshareDiv.style.width = '100%';
        const backstageButtonDiv = document.getElementById('backstage-button');
        backstageButtonDiv.insertAdjacentElement('afterend', screenshareDiv);
      }

      resetLeftPanelStyles();
      // Send signal to all clients
      handleStreamPushed(streamId, action, 'subscribers');

      sessionStorage.setItem('isScreenshareInLive', !isInMainPanel);
      changeLayout(sessionStorage.getItem('layoutSelected'));
    } catch (error) {
      console.error('Screenshare operation error:', error);

      if (
        error.message &&
        (error.message.includes('already removed') ||
          error.message.includes('not found'))
      ) {
        toast.dismiss(toastId);

        sessionStorage.setItem('isScreenshareInLive', 'false');

        let streamsInLive =
          JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
        const streamIndex = streamsInLive.findIndex((item) => item.streamId === streamId);
        if (streamIndex !== -1) {
          streamsInLive[streamIndex].inLive = false;
          sessionStorage.setItem('streamsInLive', JSON.stringify(streamsInLive));
        }

        resetLayouts();
        screenshareDiv.style.height = '25%';
        screenshareDiv.style.width = '100%';
        const backstageButtonDiv = document.getElementById('backstage-button');
        if (backstageButtonDiv && mainPanel.contains(screenshareDiv)) {
          backstageButtonDiv.insertAdjacentElement('afterend', screenshareDiv);
        }
        screenshareDiv.classList.remove('highlight-border');
        handleStreamPushed(streamId, 'removeStream', 'subscribers');

        resetLeftPanelStyles();
        changeLayout(sessionStorage.getItem('layoutSelected'));
        await getBroadcastState(true);
      } else {
        toast.error(
          `Failed to ${isInMainPanel ? 'remove' : 'add'} screenshare: ${error.message
          }`,
          { id: toastId }
        );
        screenshareDiv.classList.toggle('highlight-border');
        syncBroadcastState();
      }
    } finally {
      clearTimeout(timeoutId);
      operationsInProgress.current.delete(streamId);
      isProcessingAnyClick.current = false;

      sessionStorage.removeItem('lastStreamClickTime');

      document.querySelectorAll('[id^="OT_"]').forEach((div) => {
        div.style.pointerEvents = 'auto';
      });
      document.querySelectorAll('#hls-screen-shares > div').forEach((div) => {
        div.style.pointerEvents = 'auto';
      });
    }
  };


  useEffect(() => {
    if (isScreenSharing && isScreenshareClicked) {
      handleScreenShareClick();
    }
  }, [streamData, isScreenSharing, isScreenshareClicked]);

  // useEffect(() => {
  //   const layoutSyncInterval = setInterval(() => {
  //     const currentLayout = sessionStorage.getItem('layoutSelected');
  //     if (currentLayout) {
  //       changeLayout(currentLayout);
  //     }
  //   }, 3000);

  //   return () => clearInterval(layoutSyncInterval);
  // }, []);
  useEffect(() => {
    if (!publisher) return;

    let startTime;
    let isFirstMeasurement = true;
    let intervalId = null;

    const handleStreamCreated = () => {
      console.log('Stream created. Starting stats monitoring.');
      startTime = Date.now();

      previousVideoBytesRate.current = 0;
      previousAudioBytesRate.current = 0;
      weakNetworkCount.current = 0;
      hasWarned.current = false;
      isFirstMeasurement = true;

      if (intervalId) clearInterval(intervalId);

      intervalId = setInterval(() => {
        if (publisher?.stream && publisher?.session?.connection) {
          publisher.getStats((error, statsArray) => {
            if (error) {
              console.error('Failed to get stats:', error);
              return;
            }

            if (statsArray && statsArray.length > 0) {
              const stats = statsArray[0].stats;
              setStats(statsArray[0]?.stats);

              const currentVideoBytes = stats.video.bytesSent;
              const currentAudioBytes = stats.audio.bytesSent;

              if (isFirstMeasurement) {
                previousVideoBytesRate.current = currentVideoBytes;
                previousAudioBytesRate.current = currentAudioBytes;
                isFirstMeasurement = false;
                return;
              }

              if (
                currentVideoBytes < previousVideoBytesRate.current ||
                currentAudioBytes < previousAudioBytesRate.current
              ) {
                return;
              }

              const videoBytesKbs =
                ((currentVideoBytes - previousVideoBytesRate.current) * 8) / 1000;
              const audioBytesKbs =
                ((currentAudioBytes - previousAudioBytesRate.current) * 8) / 1000;

              previousVideoBytesRate.current = currentVideoBytes;
              previousAudioBytesRate.current = currentAudioBytes;

              setVideoKbps(videoBytesKbs);
              setAudioKbps(audioBytesKbs);

              if (Date.now() - startTime < 10000) return;

              if (!sessionStorage.getItem('broadcastId')) return;

              const audioIsActive = audioBytesKbs > 5;
              const videoHasDied = videoBytesKbs < 10;

              const isWeakNetwork = audioIsActive && videoHasDied;

              if (isWeakNetwork) {
                weakNetworkCount.current++;
              } else {
                weakNetworkCount.current = Math.max(0, weakNetworkCount.current - 1);
                if (weakNetworkCount.current === 0) {
                  hasWarned.current = false;
                }
              }

              if (weakNetworkCount.current >= 8 && !hasWarned.current) {
                toast.error(
                  'Your connection is unstable. Video/audio quality may be affected.'
                );
                hasWarned.current = true;
                weakNetworkCount.current = 0;
              }
            }
          });
        }
      }, 1000);

      publisher.on('streamDestroyed', () => {
        if (intervalId) clearInterval(intervalId);
        weakNetworkCount.current = 0;
        hasWarned.current = false;
        isFirstMeasurement = true;
      });
    };

    publisher.once('streamCreated', handleStreamCreated);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [publisher]);

  const handleScreenshareClicked = () => {
    if (sessionStorage.getItem('broadcastId')) {
      if (!canControlBroadcast()) {
        toast.error('Only Host or Co-Host can manage sources');
        return;
      }

      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const currentController = sessionStorage.getItem('activeController');

      if (!currentController || currentController !== userData.userId) {
        if (isCoHost()) {
          toast.error('You need to request control from the host first');
        } else {
          toast.error('Another user currently has broadcast control');
        }
        return;
      }
      setIsScreenshareClicked(true);
    } else {
      if (!canControlBroadcast()) {
        toast.error('Only Host or Co-Host can manage sources');
        return;
      }
      toast(`Sources can only be added to LIVE STAGE once you Go Live.`);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (sessionStorage.getItem('broadcastId')) {
        const requestOptions = {
          method: 'POST',
          redirect: 'follow',
        };

        fetch(
          `${process.env.REACT_APP_API_URL
          }/v2/livemeeting/broadcast/status/${sessionStorage.getItem(
            'broadcastId'
          )}`,
          requestOptions
        )
          .then((response) => response.json())
          .then((result) => {
            if (result?.broadcastUrls?.rtmp[0]?.status === 'live') {
              window.parent.postMessage(
                { type: 'BROADCAST_STATUS', data: result },
                '*'
              );
              clearInterval(interval);
            }
          })
          .catch((error) => console.error(error));
      }
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  function changeLayout(selectedLayout) {
    const mainPanel = document.getElementById('main-panel');
    mainPanel.classList.remove('layout-pip');
    mainPanel.classList.remove('layout-vertical');
    if (mainPanel) {
      if (selectedLayout === 'bestFit') {
        mainPanel.classList.add('layout-bestfit');
        mainPanel.style.alignItems = 'center';
        mainPanel.style.justifyContent = 'center';
      } else {
        mainPanel.classList.remove('layout-bestfit');
        mainPanel.style.alignItems = 'flex-start';
        mainPanel.style.justifyContent = 'space-between';
      }
    }
    let mainPanelDivCheck = checkDivsInMainPanel();
    if (
      (mainPanelDivCheck?.isHlsScreenSharePresent &&
        mainPanelDivCheck.otDivCount > 0) ||
      selectedLayout == 'bestFit'
    ) {
      const mainPanel = document.getElementById('main-panel');
      const screenShareDiv = document.getElementById('hls-screen-shares');
      if (!mainPanel) return;

      mainPanel.style.flexWrap = '';
      const otDivs = Array.from(mainPanel.querySelectorAll('div')).filter(
        (div) =>
          div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
      );

      if (
        (otDivs?.length > 1 && selectedLayout === 'custom') ||
        (otDivs?.length > 1 && selectedLayout === 'pip')
      ) {
        if (!sessionStorage.getItem('isToastVisible')) {
          sessionStorage.setItem('isToastVisible', true);
          toast('Can not Select more than one host for this layout', {
            id: toastId,
            duration: 2000,
          });
          setTimeout(() => {
            console.log('Clearing session storage');
            sessionStorage.removeItem('isToastVisible');
          }, 2000);
        }
      } else {
        let otWrapper = document.getElementById('ot-wrapper');

        if (selectedLayout !== 'verticalPresentation' && otWrapper) {
          otWrapper.style.display = '';
          otWrapper.style.flexDirection = '';
          otWrapper.style.width = '';
          otWrapper.style.height = '';
          otWrapper.style.marginRight = '';

          otDivs.forEach((otDiv) => {
            otDiv.style.width = '';
            otDiv.style.height = '';
            otDiv.style.marginBottom = '';
          });

          while (otWrapper.firstChild) {
            mainPanel.appendChild(otWrapper.firstChild);
          }
          otWrapper.remove();
        }

        const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
          (div) =>
            div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
        );

        if (!otDiv) {
          console.log('No div with id starting with OT found.');
          return;
        }

        if (
          selectedLayout === 'custom' ||
          selectedLayout === 'verticalPresentation'
        ) {
          const mainPanel = document.getElementById('main-panel');

          if (!mainPanel) return;
          mainPanel.style.flexWrap = '';
          mainPanel.style.display = 'flex';
          const allOtDivs = Array.from(mainPanel.querySelectorAll('div')).filter(
            (div) => div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
          );
          allOtDivs.forEach((div) => {
            div.style.width = '';
            div.style.height = '';
            div.style.marginBottom = '';
            div.style.position = '';
            div.style.top = '';
            div.style.right = '';
            div.style.zIndex = '';
          });
          const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
            (div) =>
              div.id && div.id.startsWith('OT') && !screenShareDiv.contains(div)
          );
          resetStyles(otDiv, mainPanel);
          if (otDiv) {
            if (selectedLayout === 'verticalPresentation') {
              mainPanel.classList.add('layout-vertical');
              if (otDivs.length > 1) {
                let otWrapper = document.getElementById('ot-wrapper');
                if (!otWrapper) {
                  otWrapper = document.createElement('div');
                  otWrapper.id = 'ot-wrapper';
                  mainPanel.insertBefore(otWrapper, screenShareDiv);
                }

                otWrapper.style.display = 'flex';
                otWrapper.style.flexDirection = 'column';
                otWrapper.style.width = '20%';
                otWrapper.style.height = '100%';
                otWrapper.style.marginRight = '5px';

                otDivs.forEach((otDiv) => {
                  otWrapper.appendChild(otDiv);
                  otDiv.style.width = '100%';
                  otDiv.style.height = '20%';
                  otDiv.style.marginBottom = '5px';
                });

                screenShareDiv.style.width = '100%';
                screenShareDiv.style.height = '100%';
                screenShareDiv.style.display = 'block';

                console.log(
                  'Applied vertical presentation layout for multiple otDivs with 15% size.'
                );
              } else {
                let otWrapper = document.getElementById('ot-wrapper');
                if (otWrapper) {
                  while (otWrapper.firstChild) {
                    mainPanel.appendChild(otWrapper.firstChild);
                  }
                  otWrapper.remove();
                }
                otDiv.style.height = '20%';
                otDiv.style.width = '20%';
                screenShareDiv.style.width = '100%';
                screenShareDiv.style.height = '100%';
                mainPanel.insertBefore(otDiv, screenShareDiv);
                screenShareDiv.style.marginTop = '0px';
              }
            } else {
              otDiv.style.width = '30%';
              otDiv.style.height = '100%';
              screenShareDiv.style.width = '70%';
              screenShareDiv.style.height = '100%';
            }

            console.log('Changed the width of the first OT div to 25%');
          } else {
            console.log('No div with id starting with OT found.');
          }
        } else if (selectedLayout === 'bestFit') {
          resetStyles(otDiv, mainPanel);
          if (
            mainPanelDivCheck.otDivCount === 3 ||
            (mainPanelDivCheck.otDivCount === 2 &&
              mainPanelDivCheck.isHlsScreenSharePresent)
          ) {
            const mainPanel = document.getElementById('main-panel');
            const screenShareDiv = document.getElementById('hls-screen-shares');

            mainPanel.style.display = 'flex';
            mainPanel.style.flexWrap = 'wrap';
            mainPanel.style.justifyContent = 'center';

            const otDivs = Array.from(
              mainPanel.querySelectorAll('div')
            ).filter(
              (div) =>
                div.id &&
                div.id.startsWith('OT') &&
                !screenShareDiv.contains(div)
            );

            otDivs.forEach((otDiv) => {
              otDiv.style.width = '50%';
              otDiv.style.height = '50%';
            });

            if (mainPanelDivCheck.isHlsScreenSharePresent && screenShareDiv && otDivs?.length > 1) {
              screenShareDiv.style.width = '50%';
              screenShareDiv.style.height = '50%';
              screenShareDiv.style.marginTop = '0px';
            }
            if (otDivs?.length > 3) {
              mainPanel.classList.add('more-than-3');
            } else {
              mainPanel.classList.remove('more-than-3');
            }

            return;
          }
          if (
            (mainPanelDivCheck.otDivCount > 2 &&
              mainPanelDivCheck.otDivCount < 5 &&
              !mainPanelDivCheck.isHlsScreenSharePresent) ||
            (mainPanelDivCheck.otDivCount >= 2 &&
              mainPanelDivCheck.isHlsScreenSharePresent &&
              mainPanelDivCheck.otDivCount < 4)
          ) {
            mainPanel.style.flexWrap = 'wrap';
            otDivs.forEach((otDiv, index) => {
              otDiv.style.width = '50%';
              otDiv.style.height = '45%';
            });
            if (mainPanelDivCheck.isHlsScreenSharePresent) {
              screenShareDiv.style.width = '50%';
              screenShareDiv.style.height = '45%';
            }
          } else if (
            mainPanelDivCheck.otDivCount >= 3 ||
            (mainPanelDivCheck.otDivCount >= 3 &&
              mainPanelDivCheck.isHlsScreenSharePresent)
          ) {
            mainPanel.style.display = 'flex';
            mainPanel.style.flexWrap = 'wrap';

            otDivs.forEach((otDiv, index) => {
              otDiv.style.width = '33.33%';
              otDiv.style.height = '50%';
            });
            if (mainPanelDivCheck.isHlsScreenSharePresent) {
              screenShareDiv.style.width = '33.33%';
              screenShareDiv.style.height = '50%';
            }
          } else {
            otDiv.style.height = '100%';
            otDiv.style.width = '100%';
            if (mainPanelDivCheck.isHlsScreenSharePresent) {
              screenShareDiv.style.width = '100%';
              screenShareDiv.style.height = '100%';

            }
            if (otDivs && otDivs.length > 1) {
              otDivs &&
                otDivs.forEach((otDiv) => {
                  otDiv.style.height = '100%';
                  otDiv.style.width = '100%';
                });
            }
          }
        } else if (selectedLayout === 'pip') {
          mainPanel.classList.add('layout-pip');
          const screenShareDiv = document.getElementById('hls-screen-shares');

          if (screenShareDiv && otDiv) {
            mainPanel.style.position = 'relative';

            screenShareDiv.style.width = '100%';
            screenShareDiv.style.height = '100%';

            otDiv.style.position = 'absolute';
            otDiv.style.top = '0px';
            otDiv.style.right = '10px';
            otDiv.style.width = '15%';
            otDiv.style.height = '15%';
            otDiv.style.zIndex = '10';
            console.log('Applied Picture-in-Picture layout.');
          }
        }
      }
    }
  }

  function resetStyles(otDiv, mainPanel) {
    otDiv.style.position = '';
    otDiv.style.top = '';
    otDiv.style.right = '';
    otDiv.style.zIndex = '';

    mainPanel.style.position = '';
  }

  const resetLayouts = () => {
    const mainPanel = document.getElementById('main-panel');
    const otDiv = Array.from(mainPanel.querySelectorAll('div')).find(
      (div) => div.id && div.id.startsWith('OT')
    );
    if (otDiv) {
      if (
        selectedLayout === 'verticalPresentation' ||
        selectedLayout === 'custom'
      ) {
        otDiv.style.height = '100%';
        otDiv.style.width = '100%';
      } else if (
        (selectedLayout === 'bestFit' ||
          sessionStorage.getItem('layoutSelected') === 'bestFit') &&
        mainPanelDivCheck.otDivCount === 1
      ) {
        otDiv.style.height = '100%';
        otDiv.style.width = '100%';
      } else if (selectedLayout === 'pip') {
        if (otDiv) {
          mainPanel.style.position = '';
          otDiv.style.position = '';
          otDiv.style.top = '';
          otDiv.style.right = '';
          otDiv.style.width = '100%';
          otDiv.style.height = '100%';
          otDiv.style.zIndex = '';
        }
      }
    }
  };

  // Safe periodic sync - fixes state AND moves misplaced streams
  useEffect(() => {
    if (!sessionStorage.getItem('broadcastId')) return;

    const safeSyncInterval = setInterval(async () => {
      if (
        operationsInProgress.current.size === 0 &&
        !isProcessingAnyClick.current
      ) {
        try {
          const broadcastStreams = await getBroadcastState(true);
          let streamsInLive =
            JSON.parse(sessionStorage.getItem('streamsInLive')) || [];
          const storedStreams =
            JSON.parse(sessionStorage.getItem('streams')) || [];

          let updated = false;
          const mainPanel = document.getElementById('main-panel');

          // Check each stream marked as live
          streamsInLive.forEach((localStream) => {
            if (
              localStream.inLive &&
              !broadcastStreams.includes(localStream.streamId)
            ) {
              console.warn(
                'Auto-fix: stream marked live but not in broadcast:',
                localStream.streamId
              );
              localStream.inLive = false;
              updated = true;

              // Move the stream back to backstage if it's in main panel
              const matchingStream = storedStreams.find(
                (s) => s.streamId === localStream.streamId
              );
              if (matchingStream && mainPanel) {
                const streamDiv = document.getElementById(matchingStream.id);
                if (streamDiv && mainPanel.contains(streamDiv)) {
                  console.log(
                    'Moving misplaced stream back to backstage:',
                    matchingStream.id
                  );
                  const originalContainer =
                    streamDiv.getAttribute('data-original-container') ||
                    'subscribers';
                  const targetContainer =
                    document.getElementById(originalContainer) ||
                    document.querySelector('.left-panel');
                  if (targetContainer) {
                    targetContainer.appendChild(streamDiv);
                    streamDiv.classList.remove('highlight-border');
                  }
                }
              }
            }
          });

          // Check for streams in broadcast but not marked live
          broadcastStreams.forEach((broadcastStreamId) => {
            const localStream = streamsInLive.find(
              (s) => s.streamId === broadcastStreamId
            );
            if (!localStream || !localStream.inLive) {
              console.warn(
                'Auto-fix: stream in broadcast but not marked live:',
                broadcastStreamId
              );
              const matchingStream = storedStreams.find(
                (s) => s.streamId === broadcastStreamId
              );

              if (matchingStream && mainPanel) {
                const streamDiv = document.getElementById(matchingStream.id);
                if (streamDiv && !mainPanel.contains(streamDiv)) {
                  console.log(
                    'Moving missing stream to live stage:',
                    matchingStream.id
                  );
                  mainPanel.appendChild(streamDiv);
                  streamDiv.classList.add('highlight-border');
                }
              }

              // Update session storage
              const streamIndex = streamsInLive.findIndex(
                (s) => s.streamId === broadcastStreamId
              );
              if (streamIndex === -1) {
                streamsInLive.push({
                  streamId: broadcastStreamId,
                  inLive: true,
                });
              } else {
                streamsInLive[streamIndex].inLive = true;
              }
              updated = true;
            }
          });

          if (updated) {
            sessionStorage.setItem(
              'streamsInLive',
              JSON.stringify(streamsInLive)
            );
            console.log('Auto-sync completed - fixed desync issues');
            resetLeftPanelStyles();
            changeLayout(sessionStorage.getItem('layoutSelected'));
          }
        } catch (error) {
          console.error('Background sync failed:', error);
        }
      }
    }, 8000);

    return () => clearInterval(safeSyncInterval);
  }, []);
  useEffect(() => {
    if (selectedLayout) {
      if (selectedLayout === 'custom' && sessionId) {
        getStreamData(sessionId);
      }
      changeLayout(selectedLayout);
      sessionStorage.setItem('layoutSelected', selectedLayout);

      if (window.session && !isReceivingLayoutSignal.current) {
        window.session.signal(
          {
            type: 'layout-change',
            data: selectedLayout,
          },
          (error) => {
            if (error) {
              console.error('Error sending layout change signal:', error.message);
            }
          }
        );
      }
    }
  }, [selectedLayout]);

  useEffect(() => {
    if (window.session) {
      window.session.on('signal:layout-change', (event) => {
        if (event.from?.connectionId === window.session.connection?.connectionId) {
          return;
        }

        const newLayout = event.data;

        if (newLayout === 'custom' && sessionId) {
          getStreamData(sessionId);
        }

        isReceivingLayoutSignal.current = true;
        changeLayout(newLayout);
        setSelectedLayout(newLayout);
        sessionStorage.setItem('layoutSelected', newLayout);
        setTimeout(() => {
          isReceivingLayoutSignal.current = false;
        }, 0);
      });
    }
    return () => {
      if (window.session) {
        window.session.off('signal:layout-change');
      }
    };
  }, [window.session]);


  // Validate stream still exists in session
  const validateStreamExists = (streamId) => {
    const streamExists = subscriberArrayRef.current.some(
      (sub) => sub?.streamId === streamId && sub.stream
    );

    if (!streamExists) {
      console.error(`Stream ${streamId} not found in subscriber array`);
      return false;
    }

    return true;
  };

  // Refresh subscriber array from session
  const refreshSubscriberArray = () => {
    if (!window.session) return;

    const sessionStreams = window.session.streams || [];
    const validStreamIds = sessionStreams.map((s) => s.streamId);

    // Remove stale references
    subscriberArrayRef.current = subscriberArrayRef.current.filter(
      (sub) => sub?.streamId && validStreamIds.includes(sub.streamId)
    );

    setStreams(subscriberArrayRef.current);

    // Update sessionStorage
    const data = subscriberArrayRef.current.map((item) => ({
      streamId: item.streamId,
      id: item.id,
    }));
    sessionStorage.setItem('streams', JSON.stringify(data));
  };
  const checkUserPermission = async () => {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/v2/livemeeting/permissions/${pid}`
      );
      if (response?.data?.success && response?.data?.permissions?.length > 0) {
        const currentUserPermission = response.data.permissions.find(
          (perm) => perm.userid === userData.userId
        );

        if (currentUserPermission) {
          setUserPermission(currentUserPermission.role);
          sessionStorage.setItem('IsHost', currentUserPermission.role);
        } else {
          setUserPermission(null);
        }
      } else {
        setUserPermission(null);
      }
    } catch (error) {
      console.error('Error fetching user permissions:', error);
      setUserPermission(null);
    }
  };

  useEffect(() => {
    checkUserPermission();
  }, []);

  useEffect(() => {
    if (window.session) {
      window.session.on('signal:muteAll', (event) => {
        try {
          const data = JSON.parse(event.data);
          const userData = JSON.parse(sessionStorage.getItem('userData'));
          const isHost =
            userData.role === 'host' ||
            sessionStorage.getItem('IsHost') == 1 ||
            sessionStorage.getItem('IsHost') === '1';

          if (!isHost && publisher) {
            if (data.muted) {
              publisher.publishAudio(false);
              dispatch({ type: SET_LOCAL_AUDIO, payload: false });
              localStorage.setItem('localAudio', false);

              toast('Host has muted all participants', {
                duration: 3000,
                icon: '🔇',
              });
            } else {
              publisher.publishAudio(true);
              dispatch({ type: SET_LOCAL_AUDIO, payload: true });
              localStorage.setItem('localAudio', true);
              toast('Host has unmuted all participants', {
                duration: 3000,
                icon: '🔊',
              });
            }
          }
        } catch (error) {
          console.error('Error handling mute all signal:', error);
        }
      });

      return () => {
        window.session.off('signal:muteAll');
      };
    }
  }, [window.session, publisher, dispatch]);
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <main
          className={`${condition ? 'custom-row' : ''} hls-main`}
          style={{ width: '100%' }}
        >
          <div style={{ display: 'flex' }}>
            <div
              className='left-panel'
              style={{
                width: '25vw',
                height: '80vh',
                marginTop: '45px',
                overflowY: 'scroll',
                paddingBottom: `${80 / window.devicePixelRatio}px`,
                boxSizing: 'border-box',
              }}
            >
              <div
                id='backstage-button'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {' '}
                <div className='backstage-button'>BACKSTAGE</div>
              </div>

              <div
                ref={publisherRef}
                id='publishers'
                className='camera-box'
                style={{ height: '25%', width: '100%', marginTop: '10px' }}
              ></div>
              <div
                onClick={() => handleScreenshareClicked()}
                id='hls-screen-shares'
                style={{
                  height: '25%',
                  width: '100%',
                  order: `${selectedLayout === 'bestFit' ? '' : '1'}`,
                  display: `${isScreenSharing ? 'block' : 'none'}`,
                }}
              ></div>
              <div
                ref={subscriberRef}
                id='subscribers'
                className='camera-box'
                style={{ height: '25%', width: '100%', marginTop: '20px' }}
              ></div>
            </div>
            <div
              id='main-panel'
              className='main-panel'
              style={{
                width: '73%',
                height: '85vh',
                display: 'flex',
                border: '1px solid white',
                marginTop: '10px',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <div className='live-button-container'>
                <div className='live-button'>LIVE STAGE</div>
              </div>

              {/* Broadcast starting overlay */}
              {isBroadcastStarting && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      padding: '20px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      color: 'white',
                    }}
                  >
                    <div
                      style={{
                        width: '40px',
                        height: '40px',
                        border: '3px solid rgba(255,255,255,0.3)',
                        borderTop: '3px solid white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 10px',
                      }}
                    />
                    <div>Starting broadcast...</div>
                    {isRetrying && (
                      <div style={{ fontSize: '12px', marginTop: '4px' }}>
                        Attempt {retryCount}/3
                      </div>
                    )}
                  </div>
                </div>
              )}
              {!isLoading && !isLocalUserConnected && window.session && (
                <div className='reconnect-banner' style={{ zIndex: 1000 }}>
                  <p>You have lost connection. Please reconnect.</p>
                  <button onClick={handleReconnect} className='reconnect-btn'>
                    Reconnect
                  </button>
                </div>
              )}

              <ErrorModal />
            </div>
          </div>

          {!isLoading && (
            <div
              className='hls-toolbar'
              style={{
                zoom: `${(1 / window.devicePixelRatio)}`,
              }}
            >
              <HlsToolBar
                isScreenSharing={isScreenSharing}
                startScreenSharing={startScreenSharing}
                stopScreenSharing={stopScreenSharing}
                hlsData={window.session && window.session}
                OT={window.OT}
                Publisher={publisher}
                session={window.session}
                stats={stats}
                videoKbps={videoKbps}
                audioKbps={audioKbps}
                setBroadcastType={setBroadcastType}
                setSelectedLayouts={setSelectedLayout}
                isCurrentHost={isCurrentHost}
                setOpen={setOpen}
                open={open}
                setShowNotificationChat={setShowNotificationChat}
                showNotificationChat={showNotificationChat}
                presentationId={pid}
                showControlPanel={showControlPanel}
                onToggleControlPanel={() => setShowControlPanel(prev => !prev)}
              />
              <ControlPanel />
            </div>
          )}
        </main >
        <HlsSideMenu
          session={window.session}
          isOpen={open}
          setShowNotificationChat={setShowNotificationChat}
        ></HlsSideMenu>
      </div >
    </>
  );
};

export default ManualComponent;
